/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../services/api/API.service";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateClient = /* GraphQL */ `subscription OnCreateClient($filter: ModelSubscriptionClientFilterInput) {
  onCreateClient(filter: $filter) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientSubscriptionVariables,
  APITypes.OnCreateClientSubscription
>;
export const onUpdateClient = /* GraphQL */ `subscription OnUpdateClient($filter: ModelSubscriptionClientFilterInput) {
  onUpdateClient(filter: $filter) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientSubscriptionVariables,
  APITypes.OnUpdateClientSubscription
>;
export const onDeleteClient = /* GraphQL */ `subscription OnDeleteClient($filter: ModelSubscriptionClientFilterInput) {
  onDeleteClient(filter: $filter) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientSubscriptionVariables,
  APITypes.OnDeleteClientSubscription
>;
export const onCreateClientSetting = /* GraphQL */ `subscription OnCreateClientSetting(
  $filter: ModelSubscriptionClientSettingFilterInput
) {
  onCreateClientSetting(filter: $filter) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientSettingSubscriptionVariables,
  APITypes.OnCreateClientSettingSubscription
>;
export const onUpdateClientSetting = /* GraphQL */ `subscription OnUpdateClientSetting(
  $filter: ModelSubscriptionClientSettingFilterInput
) {
  onUpdateClientSetting(filter: $filter) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientSettingSubscriptionVariables,
  APITypes.OnUpdateClientSettingSubscription
>;
export const onDeleteClientSetting = /* GraphQL */ `subscription OnDeleteClientSetting(
  $filter: ModelSubscriptionClientSettingFilterInput
) {
  onDeleteClientSetting(filter: $filter) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientSettingSubscriptionVariables,
  APITypes.OnDeleteClientSettingSubscription
>;
export const onCreateClientOption = /* GraphQL */ `subscription OnCreateClientOption(
  $filter: ModelSubscriptionClientOptionFilterInput
) {
  onCreateClientOption(filter: $filter) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    skipFMS
    clientReminders
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClientOptionSubscriptionVariables,
  APITypes.OnCreateClientOptionSubscription
>;
export const onUpdateClientOption = /* GraphQL */ `subscription OnUpdateClientOption(
  $filter: ModelSubscriptionClientOptionFilterInput
) {
  onUpdateClientOption(filter: $filter) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    skipFMS
    clientReminders
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClientOptionSubscriptionVariables,
  APITypes.OnUpdateClientOptionSubscription
>;
export const onDeleteClientOption = /* GraphQL */ `subscription OnDeleteClientOption(
  $filter: ModelSubscriptionClientOptionFilterInput
) {
  onDeleteClientOption(filter: $filter) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    skipFMS
    clientReminders
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClientOptionSubscriptionVariables,
  APITypes.OnDeleteClientOptionSubscription
>;
export const onCreateProvider = /* GraphQL */ `subscription OnCreateProvider($filter: ModelSubscriptionProviderFilterInput) {
  onCreateProvider(filter: $filter) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProviderSubscriptionVariables,
  APITypes.OnCreateProviderSubscription
>;
export const onUpdateProvider = /* GraphQL */ `subscription OnUpdateProvider($filter: ModelSubscriptionProviderFilterInput) {
  onUpdateProvider(filter: $filter) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProviderSubscriptionVariables,
  APITypes.OnUpdateProviderSubscription
>;
export const onDeleteProvider = /* GraphQL */ `subscription OnDeleteProvider($filter: ModelSubscriptionProviderFilterInput) {
  onDeleteProvider(filter: $filter) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProviderSubscriptionVariables,
  APITypes.OnDeleteProviderSubscription
>;
export const onCreateProviderSetting = /* GraphQL */ `subscription OnCreateProviderSetting(
  $filter: ModelSubscriptionProviderSettingFilterInput
) {
  onCreateProviderSetting(filter: $filter) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProviderSettingSubscriptionVariables,
  APITypes.OnCreateProviderSettingSubscription
>;
export const onUpdateProviderSetting = /* GraphQL */ `subscription OnUpdateProviderSetting(
  $filter: ModelSubscriptionProviderSettingFilterInput
) {
  onUpdateProviderSetting(filter: $filter) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProviderSettingSubscriptionVariables,
  APITypes.OnUpdateProviderSettingSubscription
>;
export const onDeleteProviderSetting = /* GraphQL */ `subscription OnDeleteProviderSetting(
  $filter: ModelSubscriptionProviderSettingFilterInput
) {
  onDeleteProviderSetting(filter: $filter) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProviderSettingSubscriptionVariables,
  APITypes.OnDeleteProviderSettingSubscription
>;
export const onCreateProviderFile = /* GraphQL */ `subscription OnCreateProviderFile(
  $filter: ModelSubscriptionProviderFileFilterInput
) {
  onCreateProviderFile(filter: $filter) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProviderFileSubscriptionVariables,
  APITypes.OnCreateProviderFileSubscription
>;
export const onUpdateProviderFile = /* GraphQL */ `subscription OnUpdateProviderFile(
  $filter: ModelSubscriptionProviderFileFilterInput
) {
  onUpdateProviderFile(filter: $filter) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProviderFileSubscriptionVariables,
  APITypes.OnUpdateProviderFileSubscription
>;
export const onDeleteProviderFile = /* GraphQL */ `subscription OnDeleteProviderFile(
  $filter: ModelSubscriptionProviderFileFilterInput
) {
  onDeleteProviderFile(filter: $filter) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProviderFileSubscriptionVariables,
  APITypes.OnDeleteProviderFileSubscription
>;
export const onCreateColors = /* GraphQL */ `subscription OnCreateColors($filter: ModelSubscriptionColorsFilterInput) {
  onCreateColors(filter: $filter) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateColorsSubscriptionVariables,
  APITypes.OnCreateColorsSubscription
>;
export const onUpdateColors = /* GraphQL */ `subscription OnUpdateColors($filter: ModelSubscriptionColorsFilterInput) {
  onUpdateColors(filter: $filter) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateColorsSubscriptionVariables,
  APITypes.OnUpdateColorsSubscription
>;
export const onDeleteColors = /* GraphQL */ `subscription OnDeleteColors($filter: ModelSubscriptionColorsFilterInput) {
  onDeleteColors(filter: $filter) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteColorsSubscriptionVariables,
  APITypes.OnDeleteColorsSubscription
>;
export const onCreateHomePageCarouselBanner = /* GraphQL */ `subscription OnCreateHomePageCarouselBanner(
  $filter: ModelSubscriptionHomePageCarouselBannerFilterInput
) {
  onCreateHomePageCarouselBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHomePageCarouselBannerSubscriptionVariables,
  APITypes.OnCreateHomePageCarouselBannerSubscription
>;
export const onUpdateHomePageCarouselBanner = /* GraphQL */ `subscription OnUpdateHomePageCarouselBanner(
  $filter: ModelSubscriptionHomePageCarouselBannerFilterInput
) {
  onUpdateHomePageCarouselBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHomePageCarouselBannerSubscriptionVariables,
  APITypes.OnUpdateHomePageCarouselBannerSubscription
>;
export const onDeleteHomePageCarouselBanner = /* GraphQL */ `subscription OnDeleteHomePageCarouselBanner(
  $filter: ModelSubscriptionHomePageCarouselBannerFilterInput
) {
  onDeleteHomePageCarouselBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHomePageCarouselBannerSubscriptionVariables,
  APITypes.OnDeleteHomePageCarouselBannerSubscription
>;
export const onCreateHomePage = /* GraphQL */ `subscription OnCreateHomePage($filter: ModelSubscriptionHomePageFilterInput) {
  onCreateHomePage(filter: $filter) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHomePageSubscriptionVariables,
  APITypes.OnCreateHomePageSubscription
>;
export const onUpdateHomePage = /* GraphQL */ `subscription OnUpdateHomePage($filter: ModelSubscriptionHomePageFilterInput) {
  onUpdateHomePage(filter: $filter) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHomePageSubscriptionVariables,
  APITypes.OnUpdateHomePageSubscription
>;
export const onDeleteHomePage = /* GraphQL */ `subscription OnDeleteHomePage($filter: ModelSubscriptionHomePageFilterInput) {
  onDeleteHomePage(filter: $filter) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHomePageSubscriptionVariables,
  APITypes.OnDeleteHomePageSubscription
>;
export const onCreateHomePageBottomBanner = /* GraphQL */ `subscription OnCreateHomePageBottomBanner(
  $filter: ModelSubscriptionHomePageBottomBannerFilterInput
) {
  onCreateHomePageBottomBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateHomePageBottomBannerSubscriptionVariables,
  APITypes.OnCreateHomePageBottomBannerSubscription
>;
export const onUpdateHomePageBottomBanner = /* GraphQL */ `subscription OnUpdateHomePageBottomBanner(
  $filter: ModelSubscriptionHomePageBottomBannerFilterInput
) {
  onUpdateHomePageBottomBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateHomePageBottomBannerSubscriptionVariables,
  APITypes.OnUpdateHomePageBottomBannerSubscription
>;
export const onDeleteHomePageBottomBanner = /* GraphQL */ `subscription OnDeleteHomePageBottomBanner(
  $filter: ModelSubscriptionHomePageBottomBannerFilterInput
) {
  onDeleteHomePageBottomBanner(filter: $filter) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteHomePageBottomBannerSubscriptionVariables,
  APITypes.OnDeleteHomePageBottomBannerSubscription
>;
export const onCreateProducto = /* GraphQL */ `subscription OnCreateProducto($filter: ModelSubscriptionProductoFilterInput) {
  onCreateProducto(filter: $filter) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    source
    trazoProductId
    trazoCategoryId
    stockUpdatedAt
    priceUpdatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductoSubscriptionVariables,
  APITypes.OnCreateProductoSubscription
>;
export const onUpdateProducto = /* GraphQL */ `subscription OnUpdateProducto($filter: ModelSubscriptionProductoFilterInput) {
  onUpdateProducto(filter: $filter) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    source
    trazoProductId
    trazoCategoryId
    stockUpdatedAt
    priceUpdatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductoSubscriptionVariables,
  APITypes.OnUpdateProductoSubscription
>;
export const onDeleteProducto = /* GraphQL */ `subscription OnDeleteProducto($filter: ModelSubscriptionProductoFilterInput) {
  onDeleteProducto(filter: $filter) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    source
    trazoProductId
    trazoCategoryId
    stockUpdatedAt
    priceUpdatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductoSubscriptionVariables,
  APITypes.OnDeleteProductoSubscription
>;
export const onCreateProductVariant = /* GraphQL */ `subscription OnCreateProductVariant(
  $filter: ModelSubscriptionProductVariantFilterInput
) {
  onCreateProductVariant(filter: $filter) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductVariantSubscriptionVariables,
  APITypes.OnCreateProductVariantSubscription
>;
export const onUpdateProductVariant = /* GraphQL */ `subscription OnUpdateProductVariant(
  $filter: ModelSubscriptionProductVariantFilterInput
) {
  onUpdateProductVariant(filter: $filter) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductVariantSubscriptionVariables,
  APITypes.OnUpdateProductVariantSubscription
>;
export const onDeleteProductVariant = /* GraphQL */ `subscription OnDeleteProductVariant(
  $filter: ModelSubscriptionProductVariantFilterInput
) {
  onDeleteProductVariant(filter: $filter) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductVariantSubscriptionVariables,
  APITypes.OnDeleteProductVariantSubscription
>;
export const onCreateProductOption = /* GraphQL */ `subscription OnCreateProductOption(
  $filter: ModelSubscriptionProductOptionFilterInput
) {
  onCreateProductOption(filter: $filter) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductOptionSubscriptionVariables,
  APITypes.OnCreateProductOptionSubscription
>;
export const onUpdateProductOption = /* GraphQL */ `subscription OnUpdateProductOption(
  $filter: ModelSubscriptionProductOptionFilterInput
) {
  onUpdateProductOption(filter: $filter) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductOptionSubscriptionVariables,
  APITypes.OnUpdateProductOptionSubscription
>;
export const onDeleteProductOption = /* GraphQL */ `subscription OnDeleteProductOption(
  $filter: ModelSubscriptionProductOptionFilterInput
) {
  onDeleteProductOption(filter: $filter) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductOptionSubscriptionVariables,
  APITypes.OnDeleteProductOptionSubscription
>;
export const onCreateProductDimention = /* GraphQL */ `subscription OnCreateProductDimention(
  $filter: ModelSubscriptionProductDimentionFilterInput
) {
  onCreateProductDimention(filter: $filter) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductDimentionSubscriptionVariables,
  APITypes.OnCreateProductDimentionSubscription
>;
export const onUpdateProductDimention = /* GraphQL */ `subscription OnUpdateProductDimention(
  $filter: ModelSubscriptionProductDimentionFilterInput
) {
  onUpdateProductDimention(filter: $filter) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductDimentionSubscriptionVariables,
  APITypes.OnUpdateProductDimentionSubscription
>;
export const onDeleteProductDimention = /* GraphQL */ `subscription OnDeleteProductDimention(
  $filter: ModelSubscriptionProductDimentionFilterInput
) {
  onDeleteProductDimention(filter: $filter) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductDimentionSubscriptionVariables,
  APITypes.OnDeleteProductDimentionSubscription
>;
export const onCreateMassiveChangeLayouts = /* GraphQL */ `subscription OnCreateMassiveChangeLayouts(
  $filter: ModelSubscriptionMassiveChangeLayoutsFilterInput
) {
  onCreateMassiveChangeLayouts(filter: $filter) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMassiveChangeLayoutsSubscriptionVariables,
  APITypes.OnCreateMassiveChangeLayoutsSubscription
>;
export const onUpdateMassiveChangeLayouts = /* GraphQL */ `subscription OnUpdateMassiveChangeLayouts(
  $filter: ModelSubscriptionMassiveChangeLayoutsFilterInput
) {
  onUpdateMassiveChangeLayouts(filter: $filter) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMassiveChangeLayoutsSubscriptionVariables,
  APITypes.OnUpdateMassiveChangeLayoutsSubscription
>;
export const onDeleteMassiveChangeLayouts = /* GraphQL */ `subscription OnDeleteMassiveChangeLayouts(
  $filter: ModelSubscriptionMassiveChangeLayoutsFilterInput
) {
  onDeleteMassiveChangeLayouts(filter: $filter) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMassiveChangeLayoutsSubscriptionVariables,
  APITypes.OnDeleteMassiveChangeLayoutsSubscription
>;
export const onCreateCategory = /* GraphQL */ `subscription OnCreateCategory($filter: ModelSubscriptionCategoryFilterInput) {
  onCreateCategory(filter: $filter) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    source
    trazoCategoryId
    nameExternal
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCategorySubscriptionVariables,
  APITypes.OnCreateCategorySubscription
>;
export const onUpdateCategory = /* GraphQL */ `subscription OnUpdateCategory($filter: ModelSubscriptionCategoryFilterInput) {
  onUpdateCategory(filter: $filter) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    source
    trazoCategoryId
    nameExternal
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCategorySubscriptionVariables,
  APITypes.OnUpdateCategorySubscription
>;
export const onDeleteCategory = /* GraphQL */ `subscription OnDeleteCategory($filter: ModelSubscriptionCategoryFilterInput) {
  onDeleteCategory(filter: $filter) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    source
    trazoCategoryId
    nameExternal
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCategorySubscriptionVariables,
  APITypes.OnDeleteCategorySubscription
>;
export const onCreateProductBrand = /* GraphQL */ `subscription OnCreateProductBrand(
  $filter: ModelSubscriptionProductBrandFilterInput
) {
  onCreateProductBrand(filter: $filter) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductBrandSubscriptionVariables,
  APITypes.OnCreateProductBrandSubscription
>;
export const onUpdateProductBrand = /* GraphQL */ `subscription OnUpdateProductBrand(
  $filter: ModelSubscriptionProductBrandFilterInput
) {
  onUpdateProductBrand(filter: $filter) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductBrandSubscriptionVariables,
  APITypes.OnUpdateProductBrandSubscription
>;
export const onDeleteProductBrand = /* GraphQL */ `subscription OnDeleteProductBrand(
  $filter: ModelSubscriptionProductBrandFilterInput
) {
  onDeleteProductBrand(filter: $filter) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductBrandSubscriptionVariables,
  APITypes.OnDeleteProductBrandSubscription
>;
export const onCreateCart = /* GraphQL */ `subscription OnCreateCart($filter: ModelSubscriptionCartFilterInput) {
  onCreateCart(filter: $filter) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCartSubscriptionVariables,
  APITypes.OnCreateCartSubscription
>;
export const onUpdateCart = /* GraphQL */ `subscription OnUpdateCart($filter: ModelSubscriptionCartFilterInput) {
  onUpdateCart(filter: $filter) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCartSubscriptionVariables,
  APITypes.OnUpdateCartSubscription
>;
export const onDeleteCart = /* GraphQL */ `subscription OnDeleteCart($filter: ModelSubscriptionCartFilterInput) {
  onDeleteCart(filter: $filter) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCartSubscriptionVariables,
  APITypes.OnDeleteCartSubscription
>;
export const onCreateUser = /* GraphQL */ `subscription OnCreateUser($filter: ModelSubscriptionUserFilterInput) {
  onCreateUser(filter: $filter) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserSubscriptionVariables,
  APITypes.OnCreateUserSubscription
>;
export const onUpdateUser = /* GraphQL */ `subscription OnUpdateUser($filter: ModelSubscriptionUserFilterInput) {
  onUpdateUser(filter: $filter) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserSubscriptionVariables,
  APITypes.OnUpdateUserSubscription
>;
export const onDeleteUser = /* GraphQL */ `subscription OnDeleteUser($filter: ModelSubscriptionUserFilterInput) {
  onDeleteUser(filter: $filter) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserSubscriptionVariables,
  APITypes.OnDeleteUserSubscription
>;
export const onCreateAutomobile = /* GraphQL */ `subscription OnCreateAutomobile(
  $filter: ModelSubscriptionAutomobileFilterInput
) {
  onCreateAutomobile(filter: $filter) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAutomobileSubscriptionVariables,
  APITypes.OnCreateAutomobileSubscription
>;
export const onUpdateAutomobile = /* GraphQL */ `subscription OnUpdateAutomobile(
  $filter: ModelSubscriptionAutomobileFilterInput
) {
  onUpdateAutomobile(filter: $filter) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAutomobileSubscriptionVariables,
  APITypes.OnUpdateAutomobileSubscription
>;
export const onDeleteAutomobile = /* GraphQL */ `subscription OnDeleteAutomobile(
  $filter: ModelSubscriptionAutomobileFilterInput
) {
  onDeleteAutomobile(filter: $filter) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAutomobileSubscriptionVariables,
  APITypes.OnDeleteAutomobileSubscription
>;
export const onCreateBrand = /* GraphQL */ `subscription OnCreateBrand($filter: ModelSubscriptionBrandFilterInput) {
  onCreateBrand(filter: $filter) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBrandSubscriptionVariables,
  APITypes.OnCreateBrandSubscription
>;
export const onUpdateBrand = /* GraphQL */ `subscription OnUpdateBrand($filter: ModelSubscriptionBrandFilterInput) {
  onUpdateBrand(filter: $filter) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBrandSubscriptionVariables,
  APITypes.OnUpdateBrandSubscription
>;
export const onDeleteBrand = /* GraphQL */ `subscription OnDeleteBrand($filter: ModelSubscriptionBrandFilterInput) {
  onDeleteBrand(filter: $filter) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBrandSubscriptionVariables,
  APITypes.OnDeleteBrandSubscription
>;
export const onCreateRfq = /* GraphQL */ `subscription OnCreateRfq($filter: ModelSubscriptionRfqFilterInput) {
  onCreateRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRfqSubscriptionVariables,
  APITypes.OnCreateRfqSubscription
>;
export const onUpdateRfq = /* GraphQL */ `subscription OnUpdateRfq($filter: ModelSubscriptionRfqFilterInput) {
  onUpdateRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRfqSubscriptionVariables,
  APITypes.OnUpdateRfqSubscription
>;
export const onDeleteRfq = /* GraphQL */ `subscription OnDeleteRfq($filter: ModelSubscriptionRfqFilterInput) {
  onDeleteRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRfqSubscriptionVariables,
  APITypes.OnDeleteRfqSubscription
>;
export const onCreateRfqAmazon = /* GraphQL */ `subscription OnCreateRfqAmazon($filter: ModelSubscriptionRfqAmazonFilterInput) {
  onCreateRfqAmazon(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRfqAmazonSubscriptionVariables,
  APITypes.OnCreateRfqAmazonSubscription
>;
export const onUpdateRfqAmazon = /* GraphQL */ `subscription OnUpdateRfqAmazon($filter: ModelSubscriptionRfqAmazonFilterInput) {
  onUpdateRfqAmazon(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRfqAmazonSubscriptionVariables,
  APITypes.OnUpdateRfqAmazonSubscription
>;
export const onDeleteRfqAmazon = /* GraphQL */ `subscription OnDeleteRfqAmazon($filter: ModelSubscriptionRfqAmazonFilterInput) {
  onDeleteRfqAmazon(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRfqAmazonSubscriptionVariables,
  APITypes.OnDeleteRfqAmazonSubscription
>;
export const onCreateProposals = /* GraphQL */ `subscription OnCreateProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onCreateProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProposalsSubscriptionVariables,
  APITypes.OnCreateProposalsSubscription
>;
export const onUpdateProposals = /* GraphQL */ `subscription OnUpdateProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onUpdateProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProposalsSubscriptionVariables,
  APITypes.OnUpdateProposalsSubscription
>;
export const onDeleteProposals = /* GraphQL */ `subscription OnDeleteProposals($filter: ModelSubscriptionProposalsFilterInput) {
  onDeleteProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProposalsSubscriptionVariables,
  APITypes.OnDeleteProposalsSubscription
>;
export const onCreateProposalsAmazon = /* GraphQL */ `subscription OnCreateProposalsAmazon(
  $filter: ModelSubscriptionProposalsAmazonFilterInput
) {
  onCreateProposalsAmazon(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProposalsAmazonSubscriptionVariables,
  APITypes.OnCreateProposalsAmazonSubscription
>;
export const onUpdateProposalsAmazon = /* GraphQL */ `subscription OnUpdateProposalsAmazon(
  $filter: ModelSubscriptionProposalsAmazonFilterInput
) {
  onUpdateProposalsAmazon(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProposalsAmazonSubscriptionVariables,
  APITypes.OnUpdateProposalsAmazonSubscription
>;
export const onDeleteProposalsAmazon = /* GraphQL */ `subscription OnDeleteProposalsAmazon(
  $filter: ModelSubscriptionProposalsAmazonFilterInput
) {
  onDeleteProposalsAmazon(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProposalsAmazonSubscriptionVariables,
  APITypes.OnDeleteProposalsAmazonSubscription
>;
export const onCreateProductoRfq = /* GraphQL */ `subscription OnCreateProductoRfq(
  $filter: ModelSubscriptionProductoRfqFilterInput
) {
  onCreateProductoRfq(filter: $filter) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductoRfqSubscriptionVariables,
  APITypes.OnCreateProductoRfqSubscription
>;
export const onUpdateProductoRfq = /* GraphQL */ `subscription OnUpdateProductoRfq(
  $filter: ModelSubscriptionProductoRfqFilterInput
) {
  onUpdateProductoRfq(filter: $filter) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductoRfqSubscriptionVariables,
  APITypes.OnUpdateProductoRfqSubscription
>;
export const onDeleteProductoRfq = /* GraphQL */ `subscription OnDeleteProductoRfq(
  $filter: ModelSubscriptionProductoRfqFilterInput
) {
  onDeleteProductoRfq(filter: $filter) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductoRfqSubscriptionVariables,
  APITypes.OnDeleteProductoRfqSubscription
>;
export const onCreateOrderProviders = /* GraphQL */ `subscription OnCreateOrderProviders(
  $filter: ModelSubscriptionOrderProvidersFilterInput
) {
  onCreateOrderProviders(filter: $filter) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderProvidersSubscriptionVariables,
  APITypes.OnCreateOrderProvidersSubscription
>;
export const onUpdateOrderProviders = /* GraphQL */ `subscription OnUpdateOrderProviders(
  $filter: ModelSubscriptionOrderProvidersFilterInput
) {
  onUpdateOrderProviders(filter: $filter) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderProvidersSubscriptionVariables,
  APITypes.OnUpdateOrderProvidersSubscription
>;
export const onDeleteOrderProviders = /* GraphQL */ `subscription OnDeleteOrderProviders(
  $filter: ModelSubscriptionOrderProvidersFilterInput
) {
  onDeleteOrderProviders(filter: $filter) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderProvidersSubscriptionVariables,
  APITypes.OnDeleteOrderProvidersSubscription
>;
export const onCreatePopMaterial = /* GraphQL */ `subscription OnCreatePopMaterial(
  $filter: ModelSubscriptionPopMaterialFilterInput
) {
  onCreatePopMaterial(filter: $filter) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopMaterialSubscriptionVariables,
  APITypes.OnCreatePopMaterialSubscription
>;
export const onUpdatePopMaterial = /* GraphQL */ `subscription OnUpdatePopMaterial(
  $filter: ModelSubscriptionPopMaterialFilterInput
) {
  onUpdatePopMaterial(filter: $filter) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopMaterialSubscriptionVariables,
  APITypes.OnUpdatePopMaterialSubscription
>;
export const onDeletePopMaterial = /* GraphQL */ `subscription OnDeletePopMaterial(
  $filter: ModelSubscriptionPopMaterialFilterInput
) {
  onDeletePopMaterial(filter: $filter) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopMaterialSubscriptionVariables,
  APITypes.OnDeletePopMaterialSubscription
>;
export const onCreateVehicleType = /* GraphQL */ `subscription OnCreateVehicleType(
  $filter: ModelSubscriptionVehicleTypeFilterInput
) {
  onCreateVehicleType(filter: $filter) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVehicleTypeSubscriptionVariables,
  APITypes.OnCreateVehicleTypeSubscription
>;
export const onUpdateVehicleType = /* GraphQL */ `subscription OnUpdateVehicleType(
  $filter: ModelSubscriptionVehicleTypeFilterInput
) {
  onUpdateVehicleType(filter: $filter) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleTypeSubscriptionVariables,
  APITypes.OnUpdateVehicleTypeSubscription
>;
export const onDeleteVehicleType = /* GraphQL */ `subscription OnDeleteVehicleType(
  $filter: ModelSubscriptionVehicleTypeFilterInput
) {
  onDeleteVehicleType(filter: $filter) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVehicleTypeSubscriptionVariables,
  APITypes.OnDeleteVehicleTypeSubscription
>;
export const onCreateVehicle = /* GraphQL */ `subscription OnCreateVehicle($filter: ModelSubscriptionVehicleFilterInput) {
  onCreateVehicle(filter: $filter) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVehicleSubscriptionVariables,
  APITypes.OnCreateVehicleSubscription
>;
export const onUpdateVehicle = /* GraphQL */ `subscription OnUpdateVehicle($filter: ModelSubscriptionVehicleFilterInput) {
  onUpdateVehicle(filter: $filter) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVehicleSubscriptionVariables,
  APITypes.OnUpdateVehicleSubscription
>;
export const onDeleteVehicle = /* GraphQL */ `subscription OnDeleteVehicle($filter: ModelSubscriptionVehicleFilterInput) {
  onDeleteVehicle(filter: $filter) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVehicleSubscriptionVariables,
  APITypes.OnDeleteVehicleSubscription
>;
export const onCreatePopOrder = /* GraphQL */ `subscription OnCreatePopOrder($filter: ModelSubscriptionPopOrderFilterInput) {
  onCreatePopOrder(filter: $filter) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopOrderSubscriptionVariables,
  APITypes.OnCreatePopOrderSubscription
>;
export const onUpdatePopOrder = /* GraphQL */ `subscription OnUpdatePopOrder($filter: ModelSubscriptionPopOrderFilterInput) {
  onUpdatePopOrder(filter: $filter) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopOrderSubscriptionVariables,
  APITypes.OnUpdatePopOrderSubscription
>;
export const onDeletePopOrder = /* GraphQL */ `subscription OnDeletePopOrder($filter: ModelSubscriptionPopOrderFilterInput) {
  onDeletePopOrder(filter: $filter) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopOrderSubscriptionVariables,
  APITypes.OnDeletePopOrderSubscription
>;
export const onCreateOrderFile = /* GraphQL */ `subscription OnCreateOrderFile($filter: ModelSubscriptionOrderFileFilterInput) {
  onCreateOrderFile(filter: $filter) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderFileSubscriptionVariables,
  APITypes.OnCreateOrderFileSubscription
>;
export const onUpdateOrderFile = /* GraphQL */ `subscription OnUpdateOrderFile($filter: ModelSubscriptionOrderFileFilterInput) {
  onUpdateOrderFile(filter: $filter) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderFileSubscriptionVariables,
  APITypes.OnUpdateOrderFileSubscription
>;
export const onDeleteOrderFile = /* GraphQL */ `subscription OnDeleteOrderFile($filter: ModelSubscriptionOrderFileFilterInput) {
  onDeleteOrderFile(filter: $filter) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderFileSubscriptionVariables,
  APITypes.OnDeleteOrderFileSubscription
>;
export const onCreatePopOrderVehicle = /* GraphQL */ `subscription OnCreatePopOrderVehicle(
  $filter: ModelSubscriptionPopOrderVehicleFilterInput
) {
  onCreatePopOrderVehicle(filter: $filter) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopOrderVehicleSubscriptionVariables,
  APITypes.OnCreatePopOrderVehicleSubscription
>;
export const onUpdatePopOrderVehicle = /* GraphQL */ `subscription OnUpdatePopOrderVehicle(
  $filter: ModelSubscriptionPopOrderVehicleFilterInput
) {
  onUpdatePopOrderVehicle(filter: $filter) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopOrderVehicleSubscriptionVariables,
  APITypes.OnUpdatePopOrderVehicleSubscription
>;
export const onDeletePopOrderVehicle = /* GraphQL */ `subscription OnDeletePopOrderVehicle(
  $filter: ModelSubscriptionPopOrderVehicleFilterInput
) {
  onDeletePopOrderVehicle(filter: $filter) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopOrderVehicleSubscriptionVariables,
  APITypes.OnDeletePopOrderVehicleSubscription
>;
export const onCreatePopOrderAuthorizer = /* GraphQL */ `subscription OnCreatePopOrderAuthorizer(
  $filter: ModelSubscriptionPopOrderAuthorizerFilterInput
) {
  onCreatePopOrderAuthorizer(filter: $filter) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopOrderAuthorizerSubscriptionVariables,
  APITypes.OnCreatePopOrderAuthorizerSubscription
>;
export const onUpdatePopOrderAuthorizer = /* GraphQL */ `subscription OnUpdatePopOrderAuthorizer(
  $filter: ModelSubscriptionPopOrderAuthorizerFilterInput
) {
  onUpdatePopOrderAuthorizer(filter: $filter) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopOrderAuthorizerSubscriptionVariables,
  APITypes.OnUpdatePopOrderAuthorizerSubscription
>;
export const onDeletePopOrderAuthorizer = /* GraphQL */ `subscription OnDeletePopOrderAuthorizer(
  $filter: ModelSubscriptionPopOrderAuthorizerFilterInput
) {
  onDeletePopOrderAuthorizer(filter: $filter) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopOrderAuthorizerSubscriptionVariables,
  APITypes.OnDeletePopOrderAuthorizerSubscription
>;
export const onCreatePopOrderProvider = /* GraphQL */ `subscription OnCreatePopOrderProvider(
  $filter: ModelSubscriptionPopOrderProviderFilterInput
) {
  onCreatePopOrderProvider(filter: $filter) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopOrderProviderSubscriptionVariables,
  APITypes.OnCreatePopOrderProviderSubscription
>;
export const onUpdatePopOrderProvider = /* GraphQL */ `subscription OnUpdatePopOrderProvider(
  $filter: ModelSubscriptionPopOrderProviderFilterInput
) {
  onUpdatePopOrderProvider(filter: $filter) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopOrderProviderSubscriptionVariables,
  APITypes.OnUpdatePopOrderProviderSubscription
>;
export const onDeletePopOrderProvider = /* GraphQL */ `subscription OnDeletePopOrderProvider(
  $filter: ModelSubscriptionPopOrderProviderFilterInput
) {
  onDeletePopOrderProvider(filter: $filter) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopOrderProviderSubscriptionVariables,
  APITypes.OnDeletePopOrderProviderSubscription
>;
export const onCreatePopOrderLog = /* GraphQL */ `subscription OnCreatePopOrderLog(
  $filter: ModelSubscriptionPopOrderLogFilterInput
) {
  onCreatePopOrderLog(filter: $filter) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopOrderLogSubscriptionVariables,
  APITypes.OnCreatePopOrderLogSubscription
>;
export const onUpdatePopOrderLog = /* GraphQL */ `subscription OnUpdatePopOrderLog(
  $filter: ModelSubscriptionPopOrderLogFilterInput
) {
  onUpdatePopOrderLog(filter: $filter) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopOrderLogSubscriptionVariables,
  APITypes.OnUpdatePopOrderLogSubscription
>;
export const onDeletePopOrderLog = /* GraphQL */ `subscription OnDeletePopOrderLog(
  $filter: ModelSubscriptionPopOrderLogFilterInput
) {
  onDeletePopOrderLog(filter: $filter) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopOrderLogSubscriptionVariables,
  APITypes.OnDeletePopOrderLogSubscription
>;
export const onCreateRfqPop = /* GraphQL */ `subscription OnCreateRfqPop($filter: ModelSubscriptionRfqPopFilterInput) {
  onCreateRfqPop(filter: $filter) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRfqPopSubscriptionVariables,
  APITypes.OnCreateRfqPopSubscription
>;
export const onUpdateRfqPop = /* GraphQL */ `subscription OnUpdateRfqPop($filter: ModelSubscriptionRfqPopFilterInput) {
  onUpdateRfqPop(filter: $filter) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRfqPopSubscriptionVariables,
  APITypes.OnUpdateRfqPopSubscription
>;
export const onDeleteRfqPop = /* GraphQL */ `subscription OnDeleteRfqPop($filter: ModelSubscriptionRfqPopFilterInput) {
  onDeleteRfqPop(filter: $filter) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRfqPopSubscriptionVariables,
  APITypes.OnDeleteRfqPopSubscription
>;
export const onCreateProposalsPop = /* GraphQL */ `subscription OnCreateProposalsPop(
  $filter: ModelSubscriptionProposalsPopFilterInput
) {
  onCreateProposalsPop(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProposalsPopSubscriptionVariables,
  APITypes.OnCreateProposalsPopSubscription
>;
export const onUpdateProposalsPop = /* GraphQL */ `subscription OnUpdateProposalsPop(
  $filter: ModelSubscriptionProposalsPopFilterInput
) {
  onUpdateProposalsPop(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProposalsPopSubscriptionVariables,
  APITypes.OnUpdateProposalsPopSubscription
>;
export const onDeleteProposalsPop = /* GraphQL */ `subscription OnDeleteProposalsPop(
  $filter: ModelSubscriptionProposalsPopFilterInput
) {
  onDeleteProposalsPop(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProposalsPopSubscriptionVariables,
  APITypes.OnDeleteProposalsPopSubscription
>;
export const onCreateUsersBrands = /* GraphQL */ `subscription OnCreateUsersBrands(
  $filter: ModelSubscriptionUsersBrandsFilterInput
) {
  onCreateUsersBrands(filter: $filter) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUsersBrandsSubscriptionVariables,
  APITypes.OnCreateUsersBrandsSubscription
>;
export const onUpdateUsersBrands = /* GraphQL */ `subscription OnUpdateUsersBrands(
  $filter: ModelSubscriptionUsersBrandsFilterInput
) {
  onUpdateUsersBrands(filter: $filter) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUsersBrandsSubscriptionVariables,
  APITypes.OnUpdateUsersBrandsSubscription
>;
export const onDeleteUsersBrands = /* GraphQL */ `subscription OnDeleteUsersBrands(
  $filter: ModelSubscriptionUsersBrandsFilterInput
) {
  onDeleteUsersBrands(filter: $filter) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUsersBrandsSubscriptionVariables,
  APITypes.OnDeleteUsersBrandsSubscription
>;
export const onCreateUserBrandSetting = /* GraphQL */ `subscription OnCreateUserBrandSetting(
  $filter: ModelSubscriptionUserBrandSettingFilterInput
) {
  onCreateUserBrandSetting(filter: $filter) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateUserBrandSettingSubscriptionVariables,
  APITypes.OnCreateUserBrandSettingSubscription
>;
export const onUpdateUserBrandSetting = /* GraphQL */ `subscription OnUpdateUserBrandSetting(
  $filter: ModelSubscriptionUserBrandSettingFilterInput
) {
  onUpdateUserBrandSetting(filter: $filter) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateUserBrandSettingSubscriptionVariables,
  APITypes.OnUpdateUserBrandSettingSubscription
>;
export const onDeleteUserBrandSetting = /* GraphQL */ `subscription OnDeleteUserBrandSetting(
  $filter: ModelSubscriptionUserBrandSettingFilterInput
) {
  onDeleteUserBrandSetting(filter: $filter) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteUserBrandSettingSubscriptionVariables,
  APITypes.OnDeleteUserBrandSettingSubscription
>;
export const onCreateLogsPUsers = /* GraphQL */ `subscription OnCreateLogsPUsers(
  $filter: ModelSubscriptionLogsPUsersFilterInput
) {
  onCreateLogsPUsers(filter: $filter) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogsPUsersSubscriptionVariables,
  APITypes.OnCreateLogsPUsersSubscription
>;
export const onUpdateLogsPUsers = /* GraphQL */ `subscription OnUpdateLogsPUsers(
  $filter: ModelSubscriptionLogsPUsersFilterInput
) {
  onUpdateLogsPUsers(filter: $filter) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogsPUsersSubscriptionVariables,
  APITypes.OnUpdateLogsPUsersSubscription
>;
export const onDeleteLogsPUsers = /* GraphQL */ `subscription OnDeleteLogsPUsers(
  $filter: ModelSubscriptionLogsPUsersFilterInput
) {
  onDeleteLogsPUsers(filter: $filter) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogsPUsersSubscriptionVariables,
  APITypes.OnDeleteLogsPUsersSubscription
>;
export const onCreateClipPayment = /* GraphQL */ `subscription OnCreateClipPayment(
  $filter: ModelSubscriptionClipPaymentFilterInput
) {
  onCreateClipPayment(filter: $filter) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateClipPaymentSubscriptionVariables,
  APITypes.OnCreateClipPaymentSubscription
>;
export const onUpdateClipPayment = /* GraphQL */ `subscription OnUpdateClipPayment(
  $filter: ModelSubscriptionClipPaymentFilterInput
) {
  onUpdateClipPayment(filter: $filter) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateClipPaymentSubscriptionVariables,
  APITypes.OnUpdateClipPaymentSubscription
>;
export const onDeleteClipPayment = /* GraphQL */ `subscription OnDeleteClipPayment(
  $filter: ModelSubscriptionClipPaymentFilterInput
) {
  onDeleteClipPayment(filter: $filter) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteClipPaymentSubscriptionVariables,
  APITypes.OnDeleteClipPaymentSubscription
>;
export const onCreateOrderProcess = /* GraphQL */ `subscription OnCreateOrderProcess(
  $filter: ModelSubscriptionOrderProcessFilterInput
) {
  onCreateOrderProcess(filter: $filter) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderProcessSubscriptionVariables,
  APITypes.OnCreateOrderProcessSubscription
>;
export const onUpdateOrderProcess = /* GraphQL */ `subscription OnUpdateOrderProcess(
  $filter: ModelSubscriptionOrderProcessFilterInput
) {
  onUpdateOrderProcess(filter: $filter) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderProcessSubscriptionVariables,
  APITypes.OnUpdateOrderProcessSubscription
>;
export const onDeleteOrderProcess = /* GraphQL */ `subscription OnDeleteOrderProcess(
  $filter: ModelSubscriptionOrderProcessFilterInput
) {
  onDeleteOrderProcess(filter: $filter) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderProcessSubscriptionVariables,
  APITypes.OnDeleteOrderProcessSubscription
>;
export const onCreateOrderSubprocess = /* GraphQL */ `subscription OnCreateOrderSubprocess(
  $filter: ModelSubscriptionOrderSubprocessFilterInput
) {
  onCreateOrderSubprocess(filter: $filter) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderSubprocessSubscriptionVariables,
  APITypes.OnCreateOrderSubprocessSubscription
>;
export const onUpdateOrderSubprocess = /* GraphQL */ `subscription OnUpdateOrderSubprocess(
  $filter: ModelSubscriptionOrderSubprocessFilterInput
) {
  onUpdateOrderSubprocess(filter: $filter) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderSubprocessSubscriptionVariables,
  APITypes.OnUpdateOrderSubprocessSubscription
>;
export const onDeleteOrderSubprocess = /* GraphQL */ `subscription OnDeleteOrderSubprocess(
  $filter: ModelSubscriptionOrderSubprocessFilterInput
) {
  onDeleteOrderSubprocess(filter: $filter) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderSubprocessSubscriptionVariables,
  APITypes.OnDeleteOrderSubprocessSubscription
>;
export const onCreatePremiumOrder = /* GraphQL */ `subscription OnCreatePremiumOrder(
  $filter: ModelSubscriptionPremiumOrderFilterInput
) {
  onCreatePremiumOrder(filter: $filter) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePremiumOrderSubscriptionVariables,
  APITypes.OnCreatePremiumOrderSubscription
>;
export const onUpdatePremiumOrder = /* GraphQL */ `subscription OnUpdatePremiumOrder(
  $filter: ModelSubscriptionPremiumOrderFilterInput
) {
  onUpdatePremiumOrder(filter: $filter) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePremiumOrderSubscriptionVariables,
  APITypes.OnUpdatePremiumOrderSubscription
>;
export const onDeletePremiumOrder = /* GraphQL */ `subscription OnDeletePremiumOrder(
  $filter: ModelSubscriptionPremiumOrderFilterInput
) {
  onDeletePremiumOrder(filter: $filter) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePremiumOrderSubscriptionVariables,
  APITypes.OnDeletePremiumOrderSubscription
>;
export const onCreatePrintedCart = /* GraphQL */ `subscription OnCreatePrintedCart(
  $filter: ModelSubscriptionPrintedCartFilterInput
) {
  onCreatePrintedCart(filter: $filter) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedCartSubscriptionVariables,
  APITypes.OnCreatePrintedCartSubscription
>;
export const onUpdatePrintedCart = /* GraphQL */ `subscription OnUpdatePrintedCart(
  $filter: ModelSubscriptionPrintedCartFilterInput
) {
  onUpdatePrintedCart(filter: $filter) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedCartSubscriptionVariables,
  APITypes.OnUpdatePrintedCartSubscription
>;
export const onDeletePrintedCart = /* GraphQL */ `subscription OnDeletePrintedCart(
  $filter: ModelSubscriptionPrintedCartFilterInput
) {
  onDeletePrintedCart(filter: $filter) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedCartSubscriptionVariables,
  APITypes.OnDeletePrintedCartSubscription
>;
export const onCreatePrintedCategory = /* GraphQL */ `subscription OnCreatePrintedCategory(
  $filter: ModelSubscriptionPrintedCategoryFilterInput
) {
  onCreatePrintedCategory(filter: $filter) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedCategorySubscriptionVariables,
  APITypes.OnCreatePrintedCategorySubscription
>;
export const onUpdatePrintedCategory = /* GraphQL */ `subscription OnUpdatePrintedCategory(
  $filter: ModelSubscriptionPrintedCategoryFilterInput
) {
  onUpdatePrintedCategory(filter: $filter) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedCategorySubscriptionVariables,
  APITypes.OnUpdatePrintedCategorySubscription
>;
export const onDeletePrintedCategory = /* GraphQL */ `subscription OnDeletePrintedCategory(
  $filter: ModelSubscriptionPrintedCategoryFilterInput
) {
  onDeletePrintedCategory(filter: $filter) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedCategorySubscriptionVariables,
  APITypes.OnDeletePrintedCategorySubscription
>;
export const onCreatePrintedSubcategory = /* GraphQL */ `subscription OnCreatePrintedSubcategory(
  $filter: ModelSubscriptionPrintedSubcategoryFilterInput
) {
  onCreatePrintedSubcategory(filter: $filter) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedSubcategorySubscriptionVariables,
  APITypes.OnCreatePrintedSubcategorySubscription
>;
export const onUpdatePrintedSubcategory = /* GraphQL */ `subscription OnUpdatePrintedSubcategory(
  $filter: ModelSubscriptionPrintedSubcategoryFilterInput
) {
  onUpdatePrintedSubcategory(filter: $filter) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedSubcategorySubscriptionVariables,
  APITypes.OnUpdatePrintedSubcategorySubscription
>;
export const onDeletePrintedSubcategory = /* GraphQL */ `subscription OnDeletePrintedSubcategory(
  $filter: ModelSubscriptionPrintedSubcategoryFilterInput
) {
  onDeletePrintedSubcategory(filter: $filter) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedSubcategorySubscriptionVariables,
  APITypes.OnDeletePrintedSubcategorySubscription
>;
export const onCreatePrintedProducts = /* GraphQL */ `subscription OnCreatePrintedProducts(
  $filter: ModelSubscriptionPrintedProductsFilterInput
) {
  onCreatePrintedProducts(filter: $filter) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedProductsSubscriptionVariables,
  APITypes.OnCreatePrintedProductsSubscription
>;
export const onUpdatePrintedProducts = /* GraphQL */ `subscription OnUpdatePrintedProducts(
  $filter: ModelSubscriptionPrintedProductsFilterInput
) {
  onUpdatePrintedProducts(filter: $filter) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedProductsSubscriptionVariables,
  APITypes.OnUpdatePrintedProductsSubscription
>;
export const onDeletePrintedProducts = /* GraphQL */ `subscription OnDeletePrintedProducts(
  $filter: ModelSubscriptionPrintedProductsFilterInput
) {
  onDeletePrintedProducts(filter: $filter) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedProductsSubscriptionVariables,
  APITypes.OnDeletePrintedProductsSubscription
>;
export const onCreatePrintedRfq = /* GraphQL */ `subscription OnCreatePrintedRfq(
  $filter: ModelSubscriptionPrintedRfqFilterInput
) {
  onCreatePrintedRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedRfqSubscriptionVariables,
  APITypes.OnCreatePrintedRfqSubscription
>;
export const onUpdatePrintedRfq = /* GraphQL */ `subscription OnUpdatePrintedRfq(
  $filter: ModelSubscriptionPrintedRfqFilterInput
) {
  onUpdatePrintedRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedRfqSubscriptionVariables,
  APITypes.OnUpdatePrintedRfqSubscription
>;
export const onDeletePrintedRfq = /* GraphQL */ `subscription OnDeletePrintedRfq(
  $filter: ModelSubscriptionPrintedRfqFilterInput
) {
  onDeletePrintedRfq(filter: $filter) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedRfqSubscriptionVariables,
  APITypes.OnDeletePrintedRfqSubscription
>;
export const onCreatePrintedProductoRfq = /* GraphQL */ `subscription OnCreatePrintedProductoRfq(
  $filter: ModelSubscriptionPrintedProductoRfqFilterInput
) {
  onCreatePrintedProductoRfq(filter: $filter) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedProductoRfqSubscriptionVariables,
  APITypes.OnCreatePrintedProductoRfqSubscription
>;
export const onUpdatePrintedProductoRfq = /* GraphQL */ `subscription OnUpdatePrintedProductoRfq(
  $filter: ModelSubscriptionPrintedProductoRfqFilterInput
) {
  onUpdatePrintedProductoRfq(filter: $filter) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedProductoRfqSubscriptionVariables,
  APITypes.OnUpdatePrintedProductoRfqSubscription
>;
export const onDeletePrintedProductoRfq = /* GraphQL */ `subscription OnDeletePrintedProductoRfq(
  $filter: ModelSubscriptionPrintedProductoRfqFilterInput
) {
  onDeletePrintedProductoRfq(filter: $filter) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedProductoRfqSubscriptionVariables,
  APITypes.OnDeletePrintedProductoRfqSubscription
>;
export const onCreatePrintedProposal = /* GraphQL */ `subscription OnCreatePrintedProposal(
  $filter: ModelSubscriptionPrintedProposalFilterInput
) {
  onCreatePrintedProposal(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedProposalSubscriptionVariables,
  APITypes.OnCreatePrintedProposalSubscription
>;
export const onUpdatePrintedProposal = /* GraphQL */ `subscription OnUpdatePrintedProposal(
  $filter: ModelSubscriptionPrintedProposalFilterInput
) {
  onUpdatePrintedProposal(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedProposalSubscriptionVariables,
  APITypes.OnUpdatePrintedProposalSubscription
>;
export const onDeletePrintedProposal = /* GraphQL */ `subscription OnDeletePrintedProposal(
  $filter: ModelSubscriptionPrintedProposalFilterInput
) {
  onDeletePrintedProposal(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedProposalSubscriptionVariables,
  APITypes.OnDeletePrintedProposalSubscription
>;
export const onCreatePrintedOrder = /* GraphQL */ `subscription OnCreatePrintedOrder(
  $filter: ModelSubscriptionPrintedOrderFilterInput
) {
  onCreatePrintedOrder(filter: $filter) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedOrderSubscriptionVariables,
  APITypes.OnCreatePrintedOrderSubscription
>;
export const onUpdatePrintedOrder = /* GraphQL */ `subscription OnUpdatePrintedOrder(
  $filter: ModelSubscriptionPrintedOrderFilterInput
) {
  onUpdatePrintedOrder(filter: $filter) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedOrderSubscriptionVariables,
  APITypes.OnUpdatePrintedOrderSubscription
>;
export const onDeletePrintedOrder = /* GraphQL */ `subscription OnDeletePrintedOrder(
  $filter: ModelSubscriptionPrintedOrderFilterInput
) {
  onDeletePrintedOrder(filter: $filter) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedOrderSubscriptionVariables,
  APITypes.OnDeletePrintedOrderSubscription
>;
export const onCreatePrintedOrderProviders = /* GraphQL */ `subscription OnCreatePrintedOrderProviders(
  $filter: ModelSubscriptionPrintedOrderProvidersFilterInput
) {
  onCreatePrintedOrderProviders(filter: $filter) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintedOrderProvidersSubscriptionVariables,
  APITypes.OnCreatePrintedOrderProvidersSubscription
>;
export const onUpdatePrintedOrderProviders = /* GraphQL */ `subscription OnUpdatePrintedOrderProviders(
  $filter: ModelSubscriptionPrintedOrderProvidersFilterInput
) {
  onUpdatePrintedOrderProviders(filter: $filter) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintedOrderProvidersSubscriptionVariables,
  APITypes.OnUpdatePrintedOrderProvidersSubscription
>;
export const onDeletePrintedOrderProviders = /* GraphQL */ `subscription OnDeletePrintedOrderProviders(
  $filter: ModelSubscriptionPrintedOrderProvidersFilterInput
) {
  onDeletePrintedOrderProviders(filter: $filter) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintedOrderProvidersSubscriptionVariables,
  APITypes.OnDeletePrintedOrderProvidersSubscription
>;
export const onCreatePayOnBehalfRequests = /* GraphQL */ `subscription OnCreatePayOnBehalfRequests(
  $filter: ModelSubscriptionPayOnBehalfRequestsFilterInput
) {
  onCreatePayOnBehalfRequests(filter: $filter) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePayOnBehalfRequestsSubscriptionVariables,
  APITypes.OnCreatePayOnBehalfRequestsSubscription
>;
export const onUpdatePayOnBehalfRequests = /* GraphQL */ `subscription OnUpdatePayOnBehalfRequests(
  $filter: ModelSubscriptionPayOnBehalfRequestsFilterInput
) {
  onUpdatePayOnBehalfRequests(filter: $filter) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePayOnBehalfRequestsSubscriptionVariables,
  APITypes.OnUpdatePayOnBehalfRequestsSubscription
>;
export const onDeletePayOnBehalfRequests = /* GraphQL */ `subscription OnDeletePayOnBehalfRequests(
  $filter: ModelSubscriptionPayOnBehalfRequestsFilterInput
) {
  onDeletePayOnBehalfRequests(filter: $filter) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePayOnBehalfRequestsSubscriptionVariables,
  APITypes.OnDeletePayOnBehalfRequestsSubscription
>;
export const onCreateBuyerContactClient = /* GraphQL */ `subscription OnCreateBuyerContactClient(
  $filter: ModelSubscriptionBuyerContactClientFilterInput
) {
  onCreateBuyerContactClient(filter: $filter) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBuyerContactClientSubscriptionVariables,
  APITypes.OnCreateBuyerContactClientSubscription
>;
export const onUpdateBuyerContactClient = /* GraphQL */ `subscription OnUpdateBuyerContactClient(
  $filter: ModelSubscriptionBuyerContactClientFilterInput
) {
  onUpdateBuyerContactClient(filter: $filter) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBuyerContactClientSubscriptionVariables,
  APITypes.OnUpdateBuyerContactClientSubscription
>;
export const onDeleteBuyerContactClient = /* GraphQL */ `subscription OnDeleteBuyerContactClient(
  $filter: ModelSubscriptionBuyerContactClientFilterInput
) {
  onDeleteBuyerContactClient(filter: $filter) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBuyerContactClientSubscriptionVariables,
  APITypes.OnDeleteBuyerContactClientSubscription
>;
export const onCreateBrandFactoryRfqEmails = /* GraphQL */ `subscription OnCreateBrandFactoryRfqEmails(
  $filter: ModelSubscriptionBrandFactoryRfqEmailsFilterInput
) {
  onCreateBrandFactoryRfqEmails(filter: $filter) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateBrandFactoryRfqEmailsSubscriptionVariables,
  APITypes.OnCreateBrandFactoryRfqEmailsSubscription
>;
export const onUpdateBrandFactoryRfqEmails = /* GraphQL */ `subscription OnUpdateBrandFactoryRfqEmails(
  $filter: ModelSubscriptionBrandFactoryRfqEmailsFilterInput
) {
  onUpdateBrandFactoryRfqEmails(filter: $filter) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateBrandFactoryRfqEmailsSubscriptionVariables,
  APITypes.OnUpdateBrandFactoryRfqEmailsSubscription
>;
export const onDeleteBrandFactoryRfqEmails = /* GraphQL */ `subscription OnDeleteBrandFactoryRfqEmails(
  $filter: ModelSubscriptionBrandFactoryRfqEmailsFilterInput
) {
  onDeleteBrandFactoryRfqEmails(filter: $filter) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteBrandFactoryRfqEmailsSubscriptionVariables,
  APITypes.OnDeleteBrandFactoryRfqEmailsSubscription
>;
export const onCreateAutomobilesEmails = /* GraphQL */ `subscription OnCreateAutomobilesEmails(
  $filter: ModelSubscriptionAutomobilesEmailsFilterInput
) {
  onCreateAutomobilesEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateAutomobilesEmailsSubscriptionVariables,
  APITypes.OnCreateAutomobilesEmailsSubscription
>;
export const onUpdateAutomobilesEmails = /* GraphQL */ `subscription OnUpdateAutomobilesEmails(
  $filter: ModelSubscriptionAutomobilesEmailsFilterInput
) {
  onUpdateAutomobilesEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateAutomobilesEmailsSubscriptionVariables,
  APITypes.OnUpdateAutomobilesEmailsSubscription
>;
export const onDeleteAutomobilesEmails = /* GraphQL */ `subscription OnDeleteAutomobilesEmails(
  $filter: ModelSubscriptionAutomobilesEmailsFilterInput
) {
  onDeleteAutomobilesEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteAutomobilesEmailsSubscriptionVariables,
  APITypes.OnDeleteAutomobilesEmailsSubscription
>;
export const onCreateQAEmails = /* GraphQL */ `subscription OnCreateQAEmails($filter: ModelSubscriptionQAEmailsFilterInput) {
  onCreateQAEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateQAEmailsSubscriptionVariables,
  APITypes.OnCreateQAEmailsSubscription
>;
export const onUpdateQAEmails = /* GraphQL */ `subscription OnUpdateQAEmails($filter: ModelSubscriptionQAEmailsFilterInput) {
  onUpdateQAEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateQAEmailsSubscriptionVariables,
  APITypes.OnUpdateQAEmailsSubscription
>;
export const onDeleteQAEmails = /* GraphQL */ `subscription OnDeleteQAEmails($filter: ModelSubscriptionQAEmailsFilterInput) {
  onDeleteQAEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteQAEmailsSubscriptionVariables,
  APITypes.OnDeleteQAEmailsSubscription
>;
export const onCreateOrderPopAdminEmails = /* GraphQL */ `subscription OnCreateOrderPopAdminEmails(
  $filter: ModelSubscriptionOrderPopAdminEmailsFilterInput
) {
  onCreateOrderPopAdminEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderPopAdminEmailsSubscriptionVariables,
  APITypes.OnCreateOrderPopAdminEmailsSubscription
>;
export const onUpdateOrderPopAdminEmails = /* GraphQL */ `subscription OnUpdateOrderPopAdminEmails(
  $filter: ModelSubscriptionOrderPopAdminEmailsFilterInput
) {
  onUpdateOrderPopAdminEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderPopAdminEmailsSubscriptionVariables,
  APITypes.OnUpdateOrderPopAdminEmailsSubscription
>;
export const onDeleteOrderPopAdminEmails = /* GraphQL */ `subscription OnDeleteOrderPopAdminEmails(
  $filter: ModelSubscriptionOrderPopAdminEmailsFilterInput
) {
  onDeleteOrderPopAdminEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderPopAdminEmailsSubscriptionVariables,
  APITypes.OnDeleteOrderPopAdminEmailsSubscription
>;
export const onCreateOrderPopCheckoutEmails = /* GraphQL */ `subscription OnCreateOrderPopCheckoutEmails(
  $filter: ModelSubscriptionOrderPopCheckoutEmailsFilterInput
) {
  onCreateOrderPopCheckoutEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateOrderPopCheckoutEmailsSubscriptionVariables,
  APITypes.OnCreateOrderPopCheckoutEmailsSubscription
>;
export const onUpdateOrderPopCheckoutEmails = /* GraphQL */ `subscription OnUpdateOrderPopCheckoutEmails(
  $filter: ModelSubscriptionOrderPopCheckoutEmailsFilterInput
) {
  onUpdateOrderPopCheckoutEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateOrderPopCheckoutEmailsSubscriptionVariables,
  APITypes.OnUpdateOrderPopCheckoutEmailsSubscription
>;
export const onDeleteOrderPopCheckoutEmails = /* GraphQL */ `subscription OnDeleteOrderPopCheckoutEmails(
  $filter: ModelSubscriptionOrderPopCheckoutEmailsFilterInput
) {
  onDeleteOrderPopCheckoutEmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteOrderPopCheckoutEmailsSubscriptionVariables,
  APITypes.OnDeleteOrderPopCheckoutEmailsSubscription
>;
export const onCreateGREmails = /* GraphQL */ `subscription OnCreateGREmails($filter: ModelSubscriptionGREmailsFilterInput) {
  onCreateGREmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateGREmailsSubscriptionVariables,
  APITypes.OnCreateGREmailsSubscription
>;
export const onUpdateGREmails = /* GraphQL */ `subscription OnUpdateGREmails($filter: ModelSubscriptionGREmailsFilterInput) {
  onUpdateGREmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateGREmailsSubscriptionVariables,
  APITypes.OnUpdateGREmailsSubscription
>;
export const onDeleteGREmails = /* GraphQL */ `subscription OnDeleteGREmails($filter: ModelSubscriptionGREmailsFilterInput) {
  onDeleteGREmails(filter: $filter) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteGREmailsSubscriptionVariables,
  APITypes.OnDeleteGREmailsSubscription
>;
export const onCreateRegions = /* GraphQL */ `subscription OnCreateRegions($filter: ModelSubscriptionRegionsFilterInput) {
  onCreateRegions(filter: $filter) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRegionsSubscriptionVariables,
  APITypes.OnCreateRegionsSubscription
>;
export const onUpdateRegions = /* GraphQL */ `subscription OnUpdateRegions($filter: ModelSubscriptionRegionsFilterInput) {
  onUpdateRegions(filter: $filter) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRegionsSubscriptionVariables,
  APITypes.OnUpdateRegionsSubscription
>;
export const onDeleteRegions = /* GraphQL */ `subscription OnDeleteRegions($filter: ModelSubscriptionRegionsFilterInput) {
  onDeleteRegions(filter: $filter) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRegionsSubscriptionVariables,
  APITypes.OnDeleteRegionsSubscription
>;
export const onCreateDefaultAddress = /* GraphQL */ `subscription OnCreateDefaultAddress(
  $filter: ModelSubscriptionDefaultAddressFilterInput
) {
  onCreateDefaultAddress(filter: $filter) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDefaultAddressSubscriptionVariables,
  APITypes.OnCreateDefaultAddressSubscription
>;
export const onUpdateDefaultAddress = /* GraphQL */ `subscription OnUpdateDefaultAddress(
  $filter: ModelSubscriptionDefaultAddressFilterInput
) {
  onUpdateDefaultAddress(filter: $filter) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDefaultAddressSubscriptionVariables,
  APITypes.OnUpdateDefaultAddressSubscription
>;
export const onDeleteDefaultAddress = /* GraphQL */ `subscription OnDeleteDefaultAddress(
  $filter: ModelSubscriptionDefaultAddressFilterInput
) {
  onDeleteDefaultAddress(filter: $filter) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDefaultAddressSubscriptionVariables,
  APITypes.OnDeleteDefaultAddressSubscription
>;
export const onCreateDefaultDeliveryContact = /* GraphQL */ `subscription OnCreateDefaultDeliveryContact(
  $filter: ModelSubscriptionDefaultDeliveryContactFilterInput
) {
  onCreateDefaultDeliveryContact(filter: $filter) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateDefaultDeliveryContactSubscriptionVariables,
  APITypes.OnCreateDefaultDeliveryContactSubscription
>;
export const onUpdateDefaultDeliveryContact = /* GraphQL */ `subscription OnUpdateDefaultDeliveryContact(
  $filter: ModelSubscriptionDefaultDeliveryContactFilterInput
) {
  onUpdateDefaultDeliveryContact(filter: $filter) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateDefaultDeliveryContactSubscriptionVariables,
  APITypes.OnUpdateDefaultDeliveryContactSubscription
>;
export const onDeleteDefaultDeliveryContact = /* GraphQL */ `subscription OnDeleteDefaultDeliveryContact(
  $filter: ModelSubscriptionDefaultDeliveryContactFilterInput
) {
  onDeleteDefaultDeliveryContact(filter: $filter) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteDefaultDeliveryContactSubscriptionVariables,
  APITypes.OnDeleteDefaultDeliveryContactSubscription
>;
export const onCreatePopCategories = /* GraphQL */ `subscription OnCreatePopCategories(
  $filter: ModelSubscriptionPopCategoriesFilterInput
) {
  onCreatePopCategories(filter: $filter) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePopCategoriesSubscriptionVariables,
  APITypes.OnCreatePopCategoriesSubscription
>;
export const onUpdatePopCategories = /* GraphQL */ `subscription OnUpdatePopCategories(
  $filter: ModelSubscriptionPopCategoriesFilterInput
) {
  onUpdatePopCategories(filter: $filter) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePopCategoriesSubscriptionVariables,
  APITypes.OnUpdatePopCategoriesSubscription
>;
export const onDeletePopCategories = /* GraphQL */ `subscription OnDeletePopCategories(
  $filter: ModelSubscriptionPopCategoriesFilterInput
) {
  onDeletePopCategories(filter: $filter) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePopCategoriesSubscriptionVariables,
  APITypes.OnDeletePopCategoriesSubscription
>;
export const onCreateRfp = /* GraphQL */ `subscription OnCreateRfp($filter: ModelSubscriptionRfpFilterInput) {
  onCreateRfp(filter: $filter) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRfpSubscriptionVariables,
  APITypes.OnCreateRfpSubscription
>;
export const onUpdateRfp = /* GraphQL */ `subscription OnUpdateRfp($filter: ModelSubscriptionRfpFilterInput) {
  onUpdateRfp(filter: $filter) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRfpSubscriptionVariables,
  APITypes.OnUpdateRfpSubscription
>;
export const onDeleteRfp = /* GraphQL */ `subscription OnDeleteRfp($filter: ModelSubscriptionRfpFilterInput) {
  onDeleteRfp(filter: $filter) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRfpSubscriptionVariables,
  APITypes.OnDeleteRfpSubscription
>;
export const onCreateRfpProposals = /* GraphQL */ `subscription OnCreateRfpProposals(
  $filter: ModelSubscriptionRfpProposalsFilterInput
) {
  onCreateRfpProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateRfpProposalsSubscriptionVariables,
  APITypes.OnCreateRfpProposalsSubscription
>;
export const onUpdateRfpProposals = /* GraphQL */ `subscription OnUpdateRfpProposals(
  $filter: ModelSubscriptionRfpProposalsFilterInput
) {
  onUpdateRfpProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateRfpProposalsSubscriptionVariables,
  APITypes.OnUpdateRfpProposalsSubscription
>;
export const onDeleteRfpProposals = /* GraphQL */ `subscription OnDeleteRfpProposals(
  $filter: ModelSubscriptionRfpProposalsFilterInput
) {
  onDeleteRfpProposals(filter: $filter) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteRfpProposalsSubscriptionVariables,
  APITypes.OnDeleteRfpProposalsSubscription
>;
export const onCreateEvaluationProviders = /* GraphQL */ `subscription OnCreateEvaluationProviders(
  $filter: ModelSubscriptionEvaluationProvidersFilterInput
) {
  onCreateEvaluationProviders(filter: $filter) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateEvaluationProvidersSubscriptionVariables,
  APITypes.OnCreateEvaluationProvidersSubscription
>;
export const onUpdateEvaluationProviders = /* GraphQL */ `subscription OnUpdateEvaluationProviders(
  $filter: ModelSubscriptionEvaluationProvidersFilterInput
) {
  onUpdateEvaluationProviders(filter: $filter) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateEvaluationProvidersSubscriptionVariables,
  APITypes.OnUpdateEvaluationProvidersSubscription
>;
export const onDeleteEvaluationProviders = /* GraphQL */ `subscription OnDeleteEvaluationProviders(
  $filter: ModelSubscriptionEvaluationProvidersFilterInput
) {
  onDeleteEvaluationProviders(filter: $filter) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteEvaluationProvidersSubscriptionVariables,
  APITypes.OnDeleteEvaluationProvidersSubscription
>;
export const onCreateLogProduct = /* GraphQL */ `subscription OnCreateLogProduct(
  $filter: ModelSubscriptionLogProductFilterInput
) {
  onCreateLogProduct(filter: $filter) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogProductSubscriptionVariables,
  APITypes.OnCreateLogProductSubscription
>;
export const onUpdateLogProduct = /* GraphQL */ `subscription OnUpdateLogProduct(
  $filter: ModelSubscriptionLogProductFilterInput
) {
  onUpdateLogProduct(filter: $filter) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogProductSubscriptionVariables,
  APITypes.OnUpdateLogProductSubscription
>;
export const onDeleteLogProduct = /* GraphQL */ `subscription OnDeleteLogProduct(
  $filter: ModelSubscriptionLogProductFilterInput
) {
  onDeleteLogProduct(filter: $filter) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogProductSubscriptionVariables,
  APITypes.OnDeleteLogProductSubscription
>;
export const onCreateLogRfq = /* GraphQL */ `subscription OnCreateLogRfq($filter: ModelSubscriptionLogRfqFilterInput) {
  onCreateLogRfq(filter: $filter) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogRfqSubscriptionVariables,
  APITypes.OnCreateLogRfqSubscription
>;
export const onUpdateLogRfq = /* GraphQL */ `subscription OnUpdateLogRfq($filter: ModelSubscriptionLogRfqFilterInput) {
  onUpdateLogRfq(filter: $filter) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogRfqSubscriptionVariables,
  APITypes.OnUpdateLogRfqSubscription
>;
export const onDeleteLogRfq = /* GraphQL */ `subscription OnDeleteLogRfq($filter: ModelSubscriptionLogRfqFilterInput) {
  onDeleteLogRfq(filter: $filter) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogRfqSubscriptionVariables,
  APITypes.OnDeleteLogRfqSubscription
>;
export const onCreateLogProductLabel = /* GraphQL */ `subscription OnCreateLogProductLabel(
  $filter: ModelSubscriptionLogProductLabelFilterInput
) {
  onCreateLogProductLabel(filter: $filter) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogProductLabelSubscriptionVariables,
  APITypes.OnCreateLogProductLabelSubscription
>;
export const onUpdateLogProductLabel = /* GraphQL */ `subscription OnUpdateLogProductLabel(
  $filter: ModelSubscriptionLogProductLabelFilterInput
) {
  onUpdateLogProductLabel(filter: $filter) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogProductLabelSubscriptionVariables,
  APITypes.OnUpdateLogProductLabelSubscription
>;
export const onDeleteLogProductLabel = /* GraphQL */ `subscription OnDeleteLogProductLabel(
  $filter: ModelSubscriptionLogProductLabelFilterInput
) {
  onDeleteLogProductLabel(filter: $filter) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogProductLabelSubscriptionVariables,
  APITypes.OnDeleteLogProductLabelSubscription
>;
export const onCreateLogGanadorAuto = /* GraphQL */ `subscription OnCreateLogGanadorAuto(
  $filter: ModelSubscriptionLogGanadorAutoFilterInput
) {
  onCreateLogGanadorAuto(filter: $filter) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogGanadorAutoSubscriptionVariables,
  APITypes.OnCreateLogGanadorAutoSubscription
>;
export const onUpdateLogGanadorAuto = /* GraphQL */ `subscription OnUpdateLogGanadorAuto(
  $filter: ModelSubscriptionLogGanadorAutoFilterInput
) {
  onUpdateLogGanadorAuto(filter: $filter) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogGanadorAutoSubscriptionVariables,
  APITypes.OnUpdateLogGanadorAutoSubscription
>;
export const onDeleteLogGanadorAuto = /* GraphQL */ `subscription OnDeleteLogGanadorAuto(
  $filter: ModelSubscriptionLogGanadorAutoFilterInput
) {
  onDeleteLogGanadorAuto(filter: $filter) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogGanadorAutoSubscriptionVariables,
  APITypes.OnDeleteLogGanadorAutoSubscription
>;
export const onCreateNotification = /* GraphQL */ `subscription OnCreateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onCreateNotification(filter: $filter) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateNotificationSubscriptionVariables,
  APITypes.OnCreateNotificationSubscription
>;
export const onUpdateNotification = /* GraphQL */ `subscription OnUpdateNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onUpdateNotification(filter: $filter) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateNotificationSubscriptionVariables,
  APITypes.OnUpdateNotificationSubscription
>;
export const onDeleteNotification = /* GraphQL */ `subscription OnDeleteNotification(
  $filter: ModelSubscriptionNotificationFilterInput
) {
  onDeleteNotification(filter: $filter) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteNotificationSubscriptionVariables,
  APITypes.OnDeleteNotificationSubscription
>;
export const onCreateMercadoCategories = /* GraphQL */ `subscription OnCreateMercadoCategories(
  $filter: ModelSubscriptionMercadoCategoriesFilterInput
) {
  onCreateMercadoCategories(filter: $filter) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMercadoCategoriesSubscriptionVariables,
  APITypes.OnCreateMercadoCategoriesSubscription
>;
export const onUpdateMercadoCategories = /* GraphQL */ `subscription OnUpdateMercadoCategories(
  $filter: ModelSubscriptionMercadoCategoriesFilterInput
) {
  onUpdateMercadoCategories(filter: $filter) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMercadoCategoriesSubscriptionVariables,
  APITypes.OnUpdateMercadoCategoriesSubscription
>;
export const onDeleteMercadoCategories = /* GraphQL */ `subscription OnDeleteMercadoCategories(
  $filter: ModelSubscriptionMercadoCategoriesFilterInput
) {
  onDeleteMercadoCategories(filter: $filter) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMercadoCategoriesSubscriptionVariables,
  APITypes.OnDeleteMercadoCategoriesSubscription
>;
export const onCreateMercadoProductCategoryClient = /* GraphQL */ `subscription OnCreateMercadoProductCategoryClient(
  $filter: ModelSubscriptionMercadoProductCategoryClientFilterInput
) {
  onCreateMercadoProductCategoryClient(filter: $filter) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateMercadoProductCategoryClientSubscriptionVariables,
  APITypes.OnCreateMercadoProductCategoryClientSubscription
>;
export const onUpdateMercadoProductCategoryClient = /* GraphQL */ `subscription OnUpdateMercadoProductCategoryClient(
  $filter: ModelSubscriptionMercadoProductCategoryClientFilterInput
) {
  onUpdateMercadoProductCategoryClient(filter: $filter) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateMercadoProductCategoryClientSubscriptionVariables,
  APITypes.OnUpdateMercadoProductCategoryClientSubscription
>;
export const onDeleteMercadoProductCategoryClient = /* GraphQL */ `subscription OnDeleteMercadoProductCategoryClient(
  $filter: ModelSubscriptionMercadoProductCategoryClientFilterInput
) {
  onDeleteMercadoProductCategoryClient(filter: $filter) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteMercadoProductCategoryClientSubscriptionVariables,
  APITypes.OnDeleteMercadoProductCategoryClientSubscription
>;
export const onCreateExternalApis = /* GraphQL */ `subscription OnCreateExternalApis(
  $filter: ModelSubscriptionExternalApisFilterInput
) {
  onCreateExternalApis(filter: $filter) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateExternalApisSubscriptionVariables,
  APITypes.OnCreateExternalApisSubscription
>;
export const onUpdateExternalApis = /* GraphQL */ `subscription OnUpdateExternalApis(
  $filter: ModelSubscriptionExternalApisFilterInput
) {
  onUpdateExternalApis(filter: $filter) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateExternalApisSubscriptionVariables,
  APITypes.OnUpdateExternalApisSubscription
>;
export const onDeleteExternalApis = /* GraphQL */ `subscription OnDeleteExternalApis(
  $filter: ModelSubscriptionExternalApisFilterInput
) {
  onDeleteExternalApis(filter: $filter) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteExternalApisSubscriptionVariables,
  APITypes.OnDeleteExternalApisSubscription
>;
export const onCreatePrintPrices = /* GraphQL */ `subscription OnCreatePrintPrices(
  $filter: ModelSubscriptionPrintPricesFilterInput
) {
  onCreatePrintPrices(filter: $filter) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintPricesSubscriptionVariables,
  APITypes.OnCreatePrintPricesSubscription
>;
export const onUpdatePrintPrices = /* GraphQL */ `subscription OnUpdatePrintPrices(
  $filter: ModelSubscriptionPrintPricesFilterInput
) {
  onUpdatePrintPrices(filter: $filter) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintPricesSubscriptionVariables,
  APITypes.OnUpdatePrintPricesSubscription
>;
export const onDeletePrintPrices = /* GraphQL */ `subscription OnDeletePrintPrices(
  $filter: ModelSubscriptionPrintPricesFilterInput
) {
  onDeletePrintPrices(filter: $filter) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintPricesSubscriptionVariables,
  APITypes.OnDeletePrintPricesSubscription
>;
export const onCreatePrintLogos = /* GraphQL */ `subscription OnCreatePrintLogos(
  $filter: ModelSubscriptionPrintLogosFilterInput
) {
  onCreatePrintLogos(filter: $filter) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePrintLogosSubscriptionVariables,
  APITypes.OnCreatePrintLogosSubscription
>;
export const onUpdatePrintLogos = /* GraphQL */ `subscription OnUpdatePrintLogos(
  $filter: ModelSubscriptionPrintLogosFilterInput
) {
  onUpdatePrintLogos(filter: $filter) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePrintLogosSubscriptionVariables,
  APITypes.OnUpdatePrintLogosSubscription
>;
export const onDeletePrintLogos = /* GraphQL */ `subscription OnDeletePrintLogos(
  $filter: ModelSubscriptionPrintLogosFilterInput
) {
  onDeletePrintLogos(filter: $filter) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePrintLogosSubscriptionVariables,
  APITypes.OnDeletePrintLogosSubscription
>;
export const onCreateLogisticPostalCode = /* GraphQL */ `subscription OnCreateLogisticPostalCode(
  $filter: ModelSubscriptionLogisticPostalCodeFilterInput
) {
  onCreateLogisticPostalCode(filter: $filter) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticPostalCodeSubscriptionVariables,
  APITypes.OnCreateLogisticPostalCodeSubscription
>;
export const onUpdateLogisticPostalCode = /* GraphQL */ `subscription OnUpdateLogisticPostalCode(
  $filter: ModelSubscriptionLogisticPostalCodeFilterInput
) {
  onUpdateLogisticPostalCode(filter: $filter) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticPostalCodeSubscriptionVariables,
  APITypes.OnUpdateLogisticPostalCodeSubscription
>;
export const onDeleteLogisticPostalCode = /* GraphQL */ `subscription OnDeleteLogisticPostalCode(
  $filter: ModelSubscriptionLogisticPostalCodeFilterInput
) {
  onDeleteLogisticPostalCode(filter: $filter) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticPostalCodeSubscriptionVariables,
  APITypes.OnDeleteLogisticPostalCodeSubscription
>;
export const onCreateLogisticPieceRange = /* GraphQL */ `subscription OnCreateLogisticPieceRange(
  $filter: ModelSubscriptionLogisticPieceRangeFilterInput
) {
  onCreateLogisticPieceRange(filter: $filter) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticPieceRangeSubscriptionVariables,
  APITypes.OnCreateLogisticPieceRangeSubscription
>;
export const onUpdateLogisticPieceRange = /* GraphQL */ `subscription OnUpdateLogisticPieceRange(
  $filter: ModelSubscriptionLogisticPieceRangeFilterInput
) {
  onUpdateLogisticPieceRange(filter: $filter) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticPieceRangeSubscriptionVariables,
  APITypes.OnUpdateLogisticPieceRangeSubscription
>;
export const onDeleteLogisticPieceRange = /* GraphQL */ `subscription OnDeleteLogisticPieceRange(
  $filter: ModelSubscriptionLogisticPieceRangeFilterInput
) {
  onDeleteLogisticPieceRange(filter: $filter) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticPieceRangeSubscriptionVariables,
  APITypes.OnDeleteLogisticPieceRangeSubscription
>;
export const onCreateLogisticWeightRange = /* GraphQL */ `subscription OnCreateLogisticWeightRange(
  $filter: ModelSubscriptionLogisticWeightRangeFilterInput
) {
  onCreateLogisticWeightRange(filter: $filter) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticWeightRangeSubscriptionVariables,
  APITypes.OnCreateLogisticWeightRangeSubscription
>;
export const onUpdateLogisticWeightRange = /* GraphQL */ `subscription OnUpdateLogisticWeightRange(
  $filter: ModelSubscriptionLogisticWeightRangeFilterInput
) {
  onUpdateLogisticWeightRange(filter: $filter) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticWeightRangeSubscriptionVariables,
  APITypes.OnUpdateLogisticWeightRangeSubscription
>;
export const onDeleteLogisticWeightRange = /* GraphQL */ `subscription OnDeleteLogisticWeightRange(
  $filter: ModelSubscriptionLogisticWeightRangeFilterInput
) {
  onDeleteLogisticWeightRange(filter: $filter) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticWeightRangeSubscriptionVariables,
  APITypes.OnDeleteLogisticWeightRangeSubscription
>;
export const onCreateLogisticWeightBox = /* GraphQL */ `subscription OnCreateLogisticWeightBox(
  $filter: ModelSubscriptionLogisticWeightBoxFilterInput
) {
  onCreateLogisticWeightBox(filter: $filter) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticWeightBoxSubscriptionVariables,
  APITypes.OnCreateLogisticWeightBoxSubscription
>;
export const onUpdateLogisticWeightBox = /* GraphQL */ `subscription OnUpdateLogisticWeightBox(
  $filter: ModelSubscriptionLogisticWeightBoxFilterInput
) {
  onUpdateLogisticWeightBox(filter: $filter) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticWeightBoxSubscriptionVariables,
  APITypes.OnUpdateLogisticWeightBoxSubscription
>;
export const onDeleteLogisticWeightBox = /* GraphQL */ `subscription OnDeleteLogisticWeightBox(
  $filter: ModelSubscriptionLogisticWeightBoxFilterInput
) {
  onDeleteLogisticWeightBox(filter: $filter) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticWeightBoxSubscriptionVariables,
  APITypes.OnDeleteLogisticWeightBoxSubscription
>;
export const onCreateLogisticZone = /* GraphQL */ `subscription OnCreateLogisticZone(
  $filter: ModelSubscriptionLogisticZoneFilterInput
) {
  onCreateLogisticZone(filter: $filter) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticZoneSubscriptionVariables,
  APITypes.OnCreateLogisticZoneSubscription
>;
export const onUpdateLogisticZone = /* GraphQL */ `subscription OnUpdateLogisticZone(
  $filter: ModelSubscriptionLogisticZoneFilterInput
) {
  onUpdateLogisticZone(filter: $filter) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticZoneSubscriptionVariables,
  APITypes.OnUpdateLogisticZoneSubscription
>;
export const onDeleteLogisticZone = /* GraphQL */ `subscription OnDeleteLogisticZone(
  $filter: ModelSubscriptionLogisticZoneFilterInput
) {
  onDeleteLogisticZone(filter: $filter) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticZoneSubscriptionVariables,
  APITypes.OnDeleteLogisticZoneSubscription
>;
export const onCreateLogisticBox = /* GraphQL */ `subscription OnCreateLogisticBox(
  $filter: ModelSubscriptionLogisticBoxFilterInput
) {
  onCreateLogisticBox(filter: $filter) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticBoxSubscriptionVariables,
  APITypes.OnCreateLogisticBoxSubscription
>;
export const onUpdateLogisticBox = /* GraphQL */ `subscription OnUpdateLogisticBox(
  $filter: ModelSubscriptionLogisticBoxFilterInput
) {
  onUpdateLogisticBox(filter: $filter) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticBoxSubscriptionVariables,
  APITypes.OnUpdateLogisticBoxSubscription
>;
export const onDeleteLogisticBox = /* GraphQL */ `subscription OnDeleteLogisticBox(
  $filter: ModelSubscriptionLogisticBoxFilterInput
) {
  onDeleteLogisticBox(filter: $filter) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticBoxSubscriptionVariables,
  APITypes.OnDeleteLogisticBoxSubscription
>;
export const onCreateLogisticVehicles = /* GraphQL */ `subscription OnCreateLogisticVehicles(
  $filter: ModelSubscriptionLogisticVehiclesFilterInput
) {
  onCreateLogisticVehicles(filter: $filter) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateLogisticVehiclesSubscriptionVariables,
  APITypes.OnCreateLogisticVehiclesSubscription
>;
export const onUpdateLogisticVehicles = /* GraphQL */ `subscription OnUpdateLogisticVehicles(
  $filter: ModelSubscriptionLogisticVehiclesFilterInput
) {
  onUpdateLogisticVehicles(filter: $filter) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateLogisticVehiclesSubscriptionVariables,
  APITypes.OnUpdateLogisticVehiclesSubscription
>;
export const onDeleteLogisticVehicles = /* GraphQL */ `subscription OnDeleteLogisticVehicles(
  $filter: ModelSubscriptionLogisticVehiclesFilterInput
) {
  onDeleteLogisticVehicles(filter: $filter) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteLogisticVehiclesSubscriptionVariables,
  APITypes.OnDeleteLogisticVehiclesSubscription
>;
export const onCreatePakmailCarrier = /* GraphQL */ `subscription OnCreatePakmailCarrier(
  $filter: ModelSubscriptionPakmailCarrierFilterInput
) {
  onCreatePakmailCarrier(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePakmailCarrierSubscriptionVariables,
  APITypes.OnCreatePakmailCarrierSubscription
>;
export const onUpdatePakmailCarrier = /* GraphQL */ `subscription OnUpdatePakmailCarrier(
  $filter: ModelSubscriptionPakmailCarrierFilterInput
) {
  onUpdatePakmailCarrier(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePakmailCarrierSubscriptionVariables,
  APITypes.OnUpdatePakmailCarrierSubscription
>;
export const onDeletePakmailCarrier = /* GraphQL */ `subscription OnDeletePakmailCarrier(
  $filter: ModelSubscriptionPakmailCarrierFilterInput
) {
  onDeletePakmailCarrier(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePakmailCarrierSubscriptionVariables,
  APITypes.OnDeletePakmailCarrierSubscription
>;
export const onCreatePakmailService = /* GraphQL */ `subscription OnCreatePakmailService(
  $filter: ModelSubscriptionPakmailServiceFilterInput
) {
  onCreatePakmailService(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePakmailServiceSubscriptionVariables,
  APITypes.OnCreatePakmailServiceSubscription
>;
export const onUpdatePakmailService = /* GraphQL */ `subscription OnUpdatePakmailService(
  $filter: ModelSubscriptionPakmailServiceFilterInput
) {
  onUpdatePakmailService(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePakmailServiceSubscriptionVariables,
  APITypes.OnUpdatePakmailServiceSubscription
>;
export const onDeletePakmailService = /* GraphQL */ `subscription OnDeletePakmailService(
  $filter: ModelSubscriptionPakmailServiceFilterInput
) {
  onDeletePakmailService(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePakmailServiceSubscriptionVariables,
  APITypes.OnDeletePakmailServiceSubscription
>;
export const onCreatePakmailShipmentStatus = /* GraphQL */ `subscription OnCreatePakmailShipmentStatus(
  $filter: ModelSubscriptionPakmailShipmentStatusFilterInput
) {
  onCreatePakmailShipmentStatus(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePakmailShipmentStatusSubscriptionVariables,
  APITypes.OnCreatePakmailShipmentStatusSubscription
>;
export const onUpdatePakmailShipmentStatus = /* GraphQL */ `subscription OnUpdatePakmailShipmentStatus(
  $filter: ModelSubscriptionPakmailShipmentStatusFilterInput
) {
  onUpdatePakmailShipmentStatus(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePakmailShipmentStatusSubscriptionVariables,
  APITypes.OnUpdatePakmailShipmentStatusSubscription
>;
export const onDeletePakmailShipmentStatus = /* GraphQL */ `subscription OnDeletePakmailShipmentStatus(
  $filter: ModelSubscriptionPakmailShipmentStatusFilterInput
) {
  onDeletePakmailShipmentStatus(filter: $filter) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePakmailShipmentStatusSubscriptionVariables,
  APITypes.OnDeletePakmailShipmentStatusSubscription
>;
export const onCreatePakmailShipmentEvent = /* GraphQL */ `subscription OnCreatePakmailShipmentEvent(
  $filter: ModelSubscriptionPakmailShipmentEventFilterInput
) {
  onCreatePakmailShipmentEvent(filter: $filter) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePakmailShipmentEventSubscriptionVariables,
  APITypes.OnCreatePakmailShipmentEventSubscription
>;
export const onUpdatePakmailShipmentEvent = /* GraphQL */ `subscription OnUpdatePakmailShipmentEvent(
  $filter: ModelSubscriptionPakmailShipmentEventFilterInput
) {
  onUpdatePakmailShipmentEvent(filter: $filter) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePakmailShipmentEventSubscriptionVariables,
  APITypes.OnUpdatePakmailShipmentEventSubscription
>;
export const onDeletePakmailShipmentEvent = /* GraphQL */ `subscription OnDeletePakmailShipmentEvent(
  $filter: ModelSubscriptionPakmailShipmentEventFilterInput
) {
  onDeletePakmailShipmentEvent(filter: $filter) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePakmailShipmentEventSubscriptionVariables,
  APITypes.OnDeletePakmailShipmentEventSubscription
>;
export const onCreatePakmailPickupStatus = /* GraphQL */ `subscription OnCreatePakmailPickupStatus(
  $filter: ModelSubscriptionPakmailPickupStatusFilterInput
) {
  onCreatePakmailPickupStatus(filter: $filter) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePakmailPickupStatusSubscriptionVariables,
  APITypes.OnCreatePakmailPickupStatusSubscription
>;
export const onUpdatePakmailPickupStatus = /* GraphQL */ `subscription OnUpdatePakmailPickupStatus(
  $filter: ModelSubscriptionPakmailPickupStatusFilterInput
) {
  onUpdatePakmailPickupStatus(filter: $filter) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePakmailPickupStatusSubscriptionVariables,
  APITypes.OnUpdatePakmailPickupStatusSubscription
>;
export const onDeletePakmailPickupStatus = /* GraphQL */ `subscription OnDeletePakmailPickupStatus(
  $filter: ModelSubscriptionPakmailPickupStatusFilterInput
) {
  onDeletePakmailPickupStatus(filter: $filter) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePakmailPickupStatusSubscriptionVariables,
  APITypes.OnDeletePakmailPickupStatusSubscription
>;
export const onCreatePremiumOrderLogisticGuide = /* GraphQL */ `subscription OnCreatePremiumOrderLogisticGuide(
  $filter: ModelSubscriptionPremiumOrderLogisticGuideFilterInput
) {
  onCreatePremiumOrderLogisticGuide(filter: $filter) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePremiumOrderLogisticGuideSubscriptionVariables,
  APITypes.OnCreatePremiumOrderLogisticGuideSubscription
>;
export const onUpdatePremiumOrderLogisticGuide = /* GraphQL */ `subscription OnUpdatePremiumOrderLogisticGuide(
  $filter: ModelSubscriptionPremiumOrderLogisticGuideFilterInput
) {
  onUpdatePremiumOrderLogisticGuide(filter: $filter) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePremiumOrderLogisticGuideSubscriptionVariables,
  APITypes.OnUpdatePremiumOrderLogisticGuideSubscription
>;
export const onDeletePremiumOrderLogisticGuide = /* GraphQL */ `subscription OnDeletePremiumOrderLogisticGuide(
  $filter: ModelSubscriptionPremiumOrderLogisticGuideFilterInput
) {
  onDeletePremiumOrderLogisticGuide(filter: $filter) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePremiumOrderLogisticGuideSubscriptionVariables,
  APITypes.OnDeletePremiumOrderLogisticGuideSubscription
>;
export const onCreateProductLabelItem = /* GraphQL */ `subscription OnCreateProductLabelItem(
  $filter: ModelSubscriptionProductLabelItemFilterInput
) {
  onCreateProductLabelItem(filter: $filter) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductLabelItemSubscriptionVariables,
  APITypes.OnCreateProductLabelItemSubscription
>;
export const onUpdateProductLabelItem = /* GraphQL */ `subscription OnUpdateProductLabelItem(
  $filter: ModelSubscriptionProductLabelItemFilterInput
) {
  onUpdateProductLabelItem(filter: $filter) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductLabelItemSubscriptionVariables,
  APITypes.OnUpdateProductLabelItemSubscription
>;
export const onDeleteProductLabelItem = /* GraphQL */ `subscription OnDeleteProductLabelItem(
  $filter: ModelSubscriptionProductLabelItemFilterInput
) {
  onDeleteProductLabelItem(filter: $filter) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductLabelItemSubscriptionVariables,
  APITypes.OnDeleteProductLabelItemSubscription
>;
export const onCreateProductLabel = /* GraphQL */ `subscription OnCreateProductLabel(
  $filter: ModelSubscriptionProductLabelFilterInput
) {
  onCreateProductLabel(filter: $filter) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductLabelSubscriptionVariables,
  APITypes.OnCreateProductLabelSubscription
>;
export const onUpdateProductLabel = /* GraphQL */ `subscription OnUpdateProductLabel(
  $filter: ModelSubscriptionProductLabelFilterInput
) {
  onUpdateProductLabel(filter: $filter) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductLabelSubscriptionVariables,
  APITypes.OnUpdateProductLabelSubscription
>;
export const onDeleteProductLabel = /* GraphQL */ `subscription OnDeleteProductLabel(
  $filter: ModelSubscriptionProductLabelFilterInput
) {
  onDeleteProductLabel(filter: $filter) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductLabelSubscriptionVariables,
  APITypes.OnDeleteProductLabelSubscription
>;
export const onCreateProductTextItem = /* GraphQL */ `subscription OnCreateProductTextItem(
  $filter: ModelSubscriptionProductTextItemFilterInput
) {
  onCreateProductTextItem(filter: $filter) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductTextItemSubscriptionVariables,
  APITypes.OnCreateProductTextItemSubscription
>;
export const onUpdateProductTextItem = /* GraphQL */ `subscription OnUpdateProductTextItem(
  $filter: ModelSubscriptionProductTextItemFilterInput
) {
  onUpdateProductTextItem(filter: $filter) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductTextItemSubscriptionVariables,
  APITypes.OnUpdateProductTextItemSubscription
>;
export const onDeleteProductTextItem = /* GraphQL */ `subscription OnDeleteProductTextItem(
  $filter: ModelSubscriptionProductTextItemFilterInput
) {
  onDeleteProductTextItem(filter: $filter) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductTextItemSubscriptionVariables,
  APITypes.OnDeleteProductTextItemSubscription
>;
export const onCreateProductText = /* GraphQL */ `subscription OnCreateProductText(
  $filter: ModelSubscriptionProductTextFilterInput
) {
  onCreateProductText(filter: $filter) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductTextSubscriptionVariables,
  APITypes.OnCreateProductTextSubscription
>;
export const onUpdateProductText = /* GraphQL */ `subscription OnUpdateProductText(
  $filter: ModelSubscriptionProductTextFilterInput
) {
  onUpdateProductText(filter: $filter) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductTextSubscriptionVariables,
  APITypes.OnUpdateProductTextSubscription
>;
export const onDeleteProductText = /* GraphQL */ `subscription OnDeleteProductText(
  $filter: ModelSubscriptionProductTextFilterInput
) {
  onDeleteProductText(filter: $filter) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductTextSubscriptionVariables,
  APITypes.OnDeleteProductTextSubscription
>;
export const onCreateProductMask = /* GraphQL */ `subscription OnCreateProductMask(
  $filter: ModelSubscriptionProductMaskFilterInput
) {
  onCreateProductMask(filter: $filter) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductMaskSubscriptionVariables,
  APITypes.OnCreateProductMaskSubscription
>;
export const onUpdateProductMask = /* GraphQL */ `subscription OnUpdateProductMask(
  $filter: ModelSubscriptionProductMaskFilterInput
) {
  onUpdateProductMask(filter: $filter) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductMaskSubscriptionVariables,
  APITypes.OnUpdateProductMaskSubscription
>;
export const onDeleteProductMask = /* GraphQL */ `subscription OnDeleteProductMask(
  $filter: ModelSubscriptionProductMaskFilterInput
) {
  onDeleteProductMask(filter: $filter) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductMaskSubscriptionVariables,
  APITypes.OnDeleteProductMaskSubscription
>;
export const onCreateVariantMask = /* GraphQL */ `subscription OnCreateVariantMask(
  $filter: ModelSubscriptionVariantMaskFilterInput
) {
  onCreateVariantMask(filter: $filter) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateVariantMaskSubscriptionVariables,
  APITypes.OnCreateVariantMaskSubscription
>;
export const onUpdateVariantMask = /* GraphQL */ `subscription OnUpdateVariantMask(
  $filter: ModelSubscriptionVariantMaskFilterInput
) {
  onUpdateVariantMask(filter: $filter) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateVariantMaskSubscriptionVariables,
  APITypes.OnUpdateVariantMaskSubscription
>;
export const onDeleteVariantMask = /* GraphQL */ `subscription OnDeleteVariantMask(
  $filter: ModelSubscriptionVariantMaskFilterInput
) {
  onDeleteVariantMask(filter: $filter) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteVariantMaskSubscriptionVariables,
  APITypes.OnDeleteVariantMaskSubscription
>;
export const onCreateProductMaskDescription = /* GraphQL */ `subscription OnCreateProductMaskDescription(
  $filter: ModelSubscriptionProductMaskDescriptionFilterInput
) {
  onCreateProductMaskDescription(filter: $filter) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateProductMaskDescriptionSubscriptionVariables,
  APITypes.OnCreateProductMaskDescriptionSubscription
>;
export const onUpdateProductMaskDescription = /* GraphQL */ `subscription OnUpdateProductMaskDescription(
  $filter: ModelSubscriptionProductMaskDescriptionFilterInput
) {
  onUpdateProductMaskDescription(filter: $filter) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateProductMaskDescriptionSubscriptionVariables,
  APITypes.OnUpdateProductMaskDescriptionSubscription
>;
export const onDeleteProductMaskDescription = /* GraphQL */ `subscription OnDeleteProductMaskDescription(
  $filter: ModelSubscriptionProductMaskDescriptionFilterInput
) {
  onDeleteProductMaskDescription(filter: $filter) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteProductMaskDescriptionSubscriptionVariables,
  APITypes.OnDeleteProductMaskDescriptionSubscription
>;
export const onCreateCoupon = /* GraphQL */ `subscription OnCreateCoupon($filter: ModelSubscriptionCouponFilterInput) {
  onCreateCoupon(filter: $filter) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCouponSubscriptionVariables,
  APITypes.OnCreateCouponSubscription
>;
export const onUpdateCoupon = /* GraphQL */ `subscription OnUpdateCoupon($filter: ModelSubscriptionCouponFilterInput) {
  onUpdateCoupon(filter: $filter) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCouponSubscriptionVariables,
  APITypes.OnUpdateCouponSubscription
>;
export const onDeleteCoupon = /* GraphQL */ `subscription OnDeleteCoupon($filter: ModelSubscriptionCouponFilterInput) {
  onDeleteCoupon(filter: $filter) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCouponSubscriptionVariables,
  APITypes.OnDeleteCouponSubscription
>;
export const onCreateCouponRedemption = /* GraphQL */ `subscription OnCreateCouponRedemption(
  $filter: ModelSubscriptionCouponRedemptionFilterInput
) {
  onCreateCouponRedemption(filter: $filter) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateCouponRedemptionSubscriptionVariables,
  APITypes.OnCreateCouponRedemptionSubscription
>;
export const onUpdateCouponRedemption = /* GraphQL */ `subscription OnUpdateCouponRedemption(
  $filter: ModelSubscriptionCouponRedemptionFilterInput
) {
  onUpdateCouponRedemption(filter: $filter) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateCouponRedemptionSubscriptionVariables,
  APITypes.OnUpdateCouponRedemptionSubscription
>;
export const onDeleteCouponRedemption = /* GraphQL */ `subscription OnDeleteCouponRedemption(
  $filter: ModelSubscriptionCouponRedemptionFilterInput
) {
  onDeleteCouponRedemption(filter: $filter) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteCouponRedemptionSubscriptionVariables,
  APITypes.OnDeleteCouponRedemptionSubscription
>;
export const onCreatePromotion = /* GraphQL */ `subscription OnCreatePromotion($filter: ModelSubscriptionPromotionFilterInput) {
  onCreatePromotion(filter: $filter) {
    id
    name
    description
    triggerProductIds
    minQuantity
    minAmount
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          minAmount
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePromotionSubscriptionVariables,
  APITypes.OnCreatePromotionSubscription
>;
export const onUpdatePromotion = /* GraphQL */ `subscription OnUpdatePromotion($filter: ModelSubscriptionPromotionFilterInput) {
  onUpdatePromotion(filter: $filter) {
    id
    name
    description
    triggerProductIds
    minQuantity
    minAmount
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          minAmount
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePromotionSubscriptionVariables,
  APITypes.OnUpdatePromotionSubscription
>;
export const onDeletePromotion = /* GraphQL */ `subscription OnDeletePromotion($filter: ModelSubscriptionPromotionFilterInput) {
  onDeletePromotion(filter: $filter) {
    id
    name
    description
    triggerProductIds
    minQuantity
    minAmount
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          minAmount
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePromotionSubscriptionVariables,
  APITypes.OnDeletePromotionSubscription
>;
export const onCreatePromotionRedemption = /* GraphQL */ `subscription OnCreatePromotionRedemption(
  $filter: ModelSubscriptionPromotionRedemptionFilterInput
) {
  onCreatePromotionRedemption(filter: $filter) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreatePromotionRedemptionSubscriptionVariables,
  APITypes.OnCreatePromotionRedemptionSubscription
>;
export const onUpdatePromotionRedemption = /* GraphQL */ `subscription OnUpdatePromotionRedemption(
  $filter: ModelSubscriptionPromotionRedemptionFilterInput
) {
  onUpdatePromotionRedemption(filter: $filter) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdatePromotionRedemptionSubscriptionVariables,
  APITypes.OnUpdatePromotionRedemptionSubscription
>;
export const onDeletePromotionRedemption = /* GraphQL */ `subscription OnDeletePromotionRedemption(
  $filter: ModelSubscriptionPromotionRedemptionFilterInput
) {
  onDeletePromotionRedemption(filter: $filter) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeletePromotionRedemptionSubscriptionVariables,
  APITypes.OnDeletePromotionRedemptionSubscription
>;
export const onCreateWalletBalance = /* GraphQL */ `subscription OnCreateWalletBalance(
  $filter: ModelSubscriptionWalletBalanceFilterInput
) {
  onCreateWalletBalance(filter: $filter) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWalletBalanceSubscriptionVariables,
  APITypes.OnCreateWalletBalanceSubscription
>;
export const onUpdateWalletBalance = /* GraphQL */ `subscription OnUpdateWalletBalance(
  $filter: ModelSubscriptionWalletBalanceFilterInput
) {
  onUpdateWalletBalance(filter: $filter) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWalletBalanceSubscriptionVariables,
  APITypes.OnUpdateWalletBalanceSubscription
>;
export const onDeleteWalletBalance = /* GraphQL */ `subscription OnDeleteWalletBalance(
  $filter: ModelSubscriptionWalletBalanceFilterInput
) {
  onDeleteWalletBalance(filter: $filter) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWalletBalanceSubscriptionVariables,
  APITypes.OnDeleteWalletBalanceSubscription
>;
export const onCreateWalletMovement = /* GraphQL */ `subscription OnCreateWalletMovement(
  $filter: ModelSubscriptionWalletMovementFilterInput
) {
  onCreateWalletMovement(filter: $filter) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateWalletMovementSubscriptionVariables,
  APITypes.OnCreateWalletMovementSubscription
>;
export const onUpdateWalletMovement = /* GraphQL */ `subscription OnUpdateWalletMovement(
  $filter: ModelSubscriptionWalletMovementFilterInput
) {
  onUpdateWalletMovement(filter: $filter) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateWalletMovementSubscriptionVariables,
  APITypes.OnUpdateWalletMovementSubscription
>;
export const onDeleteWalletMovement = /* GraphQL */ `subscription OnDeleteWalletMovement(
  $filter: ModelSubscriptionWalletMovementFilterInput
) {
  onDeleteWalletMovement(filter: $filter) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteWalletMovementSubscriptionVariables,
  APITypes.OnDeleteWalletMovementSubscription
>;
